import 'core-js';
import { domReady, windowLoaded } from "../../utilities/domready";
import * as helpers from '../../utilities/helpers';

declare var ssiAddressForm: any;
declare var deliveryAddressList: any;
declare var billingAddressList: any;
declare var payerAddressList: any;
declare var deliveryCountryCodes: any;

/*
    These Interfaces are not properly used in this file.
    The Interfaces are generated and some types are null. Change them if needed.
 */
export interface CartSummaryModel {
    isoLang:                                  string;
    numberOfProducts:                         number;
    strikeThroughItemTotal:                   number;
    itemTotalFixAmountDiscount:               number;
    itemTotal:                                number;
    handlingFeeStrikeThrough:                 number;
    handlingFee:                              number;
    freeShipping:                             boolean;
    trustedShopFee:                           number;
    netTotal:                                 number;
    vatList:                                  VatList[];
    grossTotal:                               number;
    itemFixAmountDiscountTotal:               number;
    fixAmountDiscountTotal:                   number;
    fixAmountDiscountSapTotal:                number;
    notCalculable:                            boolean;
    rounding:                                 number;
    appliedDiscounts:                         AppliedDiscount[];
    appliedSapDiscounts:                      any[];
    appliedActions:                           any[];
    missedAppliedActions:                     MissedAppliedAction[];
    giftIds:                                  any[];
    calculatedBySap:                          boolean;
    sapTimeout:                               boolean;
    cartItems:                                CartItem[];
    profile:                                  string;
    discountBreak:                            null;
    loyalityPoints:                           null;
    preliminary:                              boolean;
    strikeThroughItemTotalFormatted:          string;
    itemTotalFormatted:                       string;
    handlingFeeStrikeThroughFormatted:        string;
    handlingFeeFormatted:                     string;
    discountBreakBreakingPriceFormatted:      null;
    discountBreakReducedHandlingFeeFormatted: null;
    trustedShopFeeFormatted:                  string;
    netTotalFormatted:                        string;
    grossTotalFormatted:                      string;
    roundingFormatted:                        string;
    fixAmountDiscountTotalFormatted:          string;
    fixAmountDiscountSapTotalFormatted:       string;
    itemFixAmountDiscountTotalFormatted:      string;
    totalAppliedPercentageDiscountFormatted:  string;
    totalAppliedAbsoluteDiscountFormatted:    string;
}

export interface CartItem {
    id:                          number;
    cartId:                      number;
    cartItemId:                  number;
    pricelistName:               string;
    quantity:                    number;
    articleId:                   string;
    productId:                   string;
    shortDescription:            string;
    articleType:                 string;
    supplierNumber:              number;
    supplierArticleId:           string;
    sapSupplierNumber:           null;
    creationDate:                Date;
    price:                       null;
    parentArticleId:             null;
    costCenter:                  null;
    customerCustomization:       null;
    deliveryPeriod:              number | null;
    addBySource:                 null;
    fromPaymentCriticalCategory: boolean;
    buyable:                     boolean;
    quantityChanged:             boolean;
    copManufacturerPartNumber:   null;
    copManufacturerId:           null;
    copEan:                      null;
    copArticleDescriptionLong:   null;
    copProductGroup:             null;
    copWeight:                   null;
    copHeight:                   null;
    copLength:                   null;
    copWidth:                    null;
    copManufacturerName:         null;
    copSupplierName:             null;
    copProductManagementGroup:   null;
    techReturnWanted:            boolean;
    loadingGroup:                string;
    brandName:                   string;
    copArticle:                  boolean;
}

export interface MissedAppliedAction {
    code:                   null;
    amountFormatted:        string;
    text:                   string;
    articleId:              string;
    nextThresholdFormatted: null;
    discountMissingReason:  string;
    publicText:             string;
}

export interface VatList {
    percent:         number;
    amount:          number;
    amountFormatted: string;
}

interface AppliedDiscount {
    campaignCodes: string[];
    promoCodes: string[];
    discountType: string;
    percentageAmount: number;
}

interface CartItemPrice {
    cartItemId: string;
    priceListName: string;
    articleId: string;
    appliedDiscounts: AppliedDiscount[];
}

export class Main {

    cartPricesUpdated = 0;
    failedLogging = 0;

    // To be gotten from window element in getFtlData()
    digitalData: any;
    _satellite: any;
    disableProfileSwitches: any;
    renderArticleToCart: any;
    insurancePushCart: any;
    urlPrefix: any;
    dtmPage: string;
    cartType: string;
    mp: {[index: string]: string};

    disableButton(btn: HTMLButtonElement) {
        btn.classList.remove('btn-default');
        btn.classList.add('btn-clickevent');
        btn.disabled = true;
        btn.style.cursor = 'not-allowed';
        btn.style.pointerEvents = 'none';
        btn.style.opacity = '.4';
        btn.style.background = 'rgba(144,144,144,.2)';
    }

    enableButton(btn: HTMLButtonElement) {
        btn.classList.remove('btn-clickevent');
        btn.classList.add('btn-default');
        btn.disabled = false;
        btn.style.cursor = 'pointer';
        btn.style.pointerEvents = 'all';
        btn.style.opacity = '1';
        btn.disabled = false;
        btn.style.removeProperty('background');
    }

    submitOrderDetails(name: string, value: string) {
        const params: {[index: string]:string} = {};
        params[name] = value;

        const XHR = new XMLHttpRequest()
        XHR.open('POST', '/order/checkout/summary/' + name)
        XHR.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8')
        XHR.setRequestHeader('X-Requested-With', 'XMLHttpRequest')
        XHR.send(name + '=' + value);
    }

    public updateCartPrices(cartType: string, sap: boolean, dtmPage: string, mp: {[index: string]:string}) {

        function handleDisplayPromocode(appliedActions: Array<any>) {
            // $('.applied-modifier-item').each(function () {
            //$(this).hide();
            // });

            let code,
              el: HTMLElement;

            for (let a = 0; a < appliedActions.length; a++) {
                code = appliedActions[a].code;
                if(code != null) {
                    el = document.querySelector('.promocode-' + code);

                    if(el) {
                        el.classList.remove('promocode-missed');
                        if (!el.classList.contains('label-info')) {
                            el.classList.add('label-info');
                        }
                        el.style.display = 'flex';
                    }
                }
            }
        }

        function handleDisplayPromocodeFromItems(items: Array<any>) {
            for (let i = 0; i < items.length; i++) {
                const appliedDiscounts = items[i].appliedDiscounts;
                if (appliedDiscounts.length > 0) {
                    for (let a = 0; a < appliedDiscounts.length; a++) {
                        if (appliedDiscounts[a].promoCodes.length > 0) {
                            for (let p = 0; p < appliedDiscounts[a].promoCodes.length; p++) {
                                const promoCode = appliedDiscounts[a].promoCodes[p];
                                if (promoCode != null) {
                                    const el:HTMLElement = document.querySelector('.promocode-' + promoCode);
                                    if(el) {
                                        el.classList.remove('promocode-missed');
                                        if (!el.classList.contains('label-info')) {
                                            el.classList.add('label-info');
                                        }
                                        el.style.display = 'flex';
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }

        function displayVoucherCodes(data: any) {
            const appliedActionElement = document.querySelector(
              "#voucherremaining.template",
            );

            if (!appliedActionElement) return;

            const appliedActionsContainerElement = document.querySelector(
              "#voucher-applied-actions-container",
            );
            const hasMissedAppliedActions =
              data?.cartSummaryModel?.missedAppliedActions?.length > 0;

            // If cart has missed applied actions
            if (hasMissedAppliedActions) {

                // Filter out duplicate missedAppliedActions
                const seenReasons = new Set();
                const filteredMissedAppliedActions  = data.cartSummaryModel.missedAppliedActions.filter((action: MissedAppliedAction) => {
                    if (seenReasons.has(action.discountMissingReason)) {
                        return false;
                    }
                    seenReasons.add(action.discountMissingReason);
                    return true;
                });

                filteredMissedAppliedActions.forEach((action: MissedAppliedAction) => {

                    if(action.discountMissingReason === 'NOT_APPLICABLE_FOR_DISCOUNTED_ARTICLES') return

                    const copy = appliedActionElement.cloneNode(true) as HTMLDivElement;
                    const text = copy.querySelector(".voucherremaining-text");

                    text.innerHTML = action.text;
                    copy.classList.remove("hidden");
                    copy.classList.remove("template");
                    appliedActionsContainerElement.appendChild(copy);
                });  }
            // From cartSummaryModel -> Discounts for the whole cart
            if (
              !hasMissedAppliedActions &&
              data?.cartSummaryModel?.appliedDiscounts?.length > 0
            ) {
                const copy = appliedActionElement.cloneNode(true) as HTMLDivElement;

                copy.classList.remove("hidden");
                copy.classList.remove("template");
                appliedActionsContainerElement.appendChild(copy);
            }
            // From cartItemPrices -> Discounts for each item in cart
            if (!hasMissedAppliedActions && data?.cartItemPrices?.length > 0) {
                const hasAppliedPositionDiscounts = data.cartItemPrices.some(
                  (item: any) => item.appliedDiscounts?.length > 0,
                );    if (hasAppliedPositionDiscounts) {
                    const copy = appliedActionElement.cloneNode(true) as HTMLDivElement;

                    copy.classList.remove("hidden");
                    copy.classList.remove("template");
                    appliedActionsContainerElement.appendChild(copy);
                }
            }
        }

        function handleDisplayMissedPromocode(missedAppliedActions: Array<any>) {
            if (typeof missedAppliedActions == 'undefined' || missedAppliedActions.length < 1 || (_this.dtmPage != 'cart' && _this.dtmPage != 'summary') ) {
                return;
            }

            //collect missed discounts
            let missedAppliedActionsTexts = [],
              missedAppliedActionsTextArticle = [],
              code,
              el: HTMLElement;
            for (let a = 0; a < missedAppliedActions.length; a++) {
                if (missedAppliedActions[a].articleId == null && missedAppliedActions[a].discountMissingReason != 'THRESHOLD_NOT_REACHED_FOR_DISCOUNT_BREAK') {
                    missedAppliedActionsTexts.push(missedAppliedActions[a].text);
                } else if (missedAppliedActions[a].discountMissingReason == 'THRESHOLD_NOT_REACHED_FOR_DISCOUNT_BREAK') {
                    const actionBox = document.getElementById('discount-break-action-box');
                    if (actionBox) {
                        actionBox.classList.remove('hidden');
                        actionBox.querySelector('#discount-break-action-content').innerHTML = missedAppliedActions[a].text;
                    }
                } else {
                    if (missedAppliedActionsTextArticle[missedAppliedActions[a].articleId] === undefined) {
                        missedAppliedActionsTextArticle[missedAppliedActions[a].articleId] = '';
                    }
                    missedAppliedActionsTextArticle[missedAppliedActions[a].articleId] += missedAppliedActions[a].text;
                }

                code = missedAppliedActions[a].code;
                if(code != null) {
                    el = document.querySelector('.promocode-' + code);
                    if(el) {
                        if (!el.classList.contains('promocode-missed')) {
                            el.classList.add('promocode-missed');
                        }
                        el.classList.remove('label-info')
                        el.style.display = 'flex';
                    }
                }
            }


            //fill fields and show
            if (missedAppliedActionsTexts.length > 0) {
                if(document.getElementById('basket-not-applied-action-box')) {
                    const actionBox = document.getElementById('basket-not-applied-action-box');
                    let lastBox : HTMLElement = actionBox;
                    for (let a = 0; a < missedAppliedActionsTexts.length; a++) {
                        const newBox = (<HTMLElement>actionBox.cloneNode(true));
                        newBox.classList.remove('hidden');
                        newBox.id = newBox.id + '' + a;
                        const newBoxContent = newBox.querySelector('#basket-not-applied-action-content');
                        newBoxContent.id = newBoxContent.id + '' + a;
                        newBoxContent.innerHTML = missedAppliedActionsTexts[a];
                        lastBox.after(newBox);
                        lastBox = newBox;
                    }
                }
            }

            for (let a = 0; a < missedAppliedActions.length; a++) {
                const curArticleId = missedAppliedActions[a].articleId;
                if (curArticleId != null) {
                    const curText = missedAppliedActionsTextArticle[curArticleId];

                    document.getElementById('basket-not-applied-action-content-' + curArticleId).innerHTML = curText;
                    document.getElementById('basket-missed-condition-' + curArticleId).classList.remove('hidden');
                }
            }
        }

        function markAsUnavailable(cartItemId: number, mp: {[index: string]:string}) {
            const elem: HTMLElement = document.querySelector('.divTableRow[data-order-cart-item-id="' + cartItemId + '"]');
            if(elem.querySelector('.basket-item-image a')) {
                (<HTMLElement>elem.querySelector('.basket-item-image a')).style.pointerEvents = 'none';
                (<HTMLElement>elem.querySelector('.basket-item-image a')).style.cursor = 'default';
            }
            if(elem.querySelector('.basket-item-text a')) {
                helpers.rewrap(elem.querySelector('.basket-item-text a'), 'div');
            }

            (<HTMLElement>elem.querySelector('.divTableCell:first-child')).style.opacity = '.4';
            if(elem.querySelector('.basket-price-single')) {
                elem.querySelector('.basket-price-single').parentElement.style.opacity = '.4';
            }
            if(elem.querySelector('.price-' + cartItemId + '-articlePrice')) {
                (<HTMLElement>elem.querySelector('.price-' + cartItemId + '-articlePrice')).style.visibility = 'hidden';
            }
            if(elem.querySelector('.form-cart-item-update')) {
                elem.querySelector('.form-cart-item-update').innerHTML = '<div class="msg small msg-orange msg-borderless"><div class="msg-container"><div><svg class="icn"><use xlink:href="#shape-info-red" /></svg></div><div>' + mp['out_of_stock'] + '</div></div></div>';
            }
            // kann vermutlich weg
            if(elem.querySelector('.fa-sync-alt')) {
                elem.querySelector('.fa-sync-alt').parentElement.style.visibility = 'hidden';
            }

            if(elem.querySelector('.toggle-configurator')) {
                (<HTMLElement>elem.querySelector('.toggle-configurator')).style.display = 'none';
            }
            if(elem.querySelector('.cart-more-is-better')) {
                (<HTMLElement>elem.querySelector('.cart-more-is-better')).style.display = 'none';
            }
        }

        function deactivateOrder() {
            (<HTMLElement>document.querySelector('.toggle-basket-summary-voucher')).style.pointerEvents = 'none';
            document.querySelector('.toggle-basket-summary-voucher').removeAttribute('href');
            document.querySelector('.btn-checkout').removeAttribute('href');
            const pdfCheckout = <HTMLElement>document.querySelector('.pdf-checkout');
            if (pdfCheckout) {
                pdfCheckout.style.opacity = '0.4';
            }
            const els: Array<HTMLElement> = Array.from(document.querySelectorAll('.pdf-checkout a'));
            els.forEach(el => el.removeAttribute('href'));
            els.forEach(el => helpers.rewrap(el, 'div'));
        }

        function redirectToCartOrPendingCommission(data: any) {
            const orderSub = document.getElementById('order-sub').getAttribute('data-order-sub');
            let cartItemPricesCount = 0;

            if (typeof orderSub !== 'undefined') {
                if (data.cartItemPrices != null) {
                    cartItemPricesCount = data.cartItemPrices.length;
                }
                if (data.cartSummaryModel.cartItems == null && cartItemPricesCount == 0 && data.cartPurchasable === false && data.cartSummaryModel.calculatedBySap === false) {
                    if (orderSub == '') {
                        location.reload();
                    } else {
                        window.location.href = '/order/commission/payment/pending/' + orderSub;
                    }
                }
            }
        }

        /**
         * DTM functions for checkout
         */

        function dtmUpdateTracking(dtmPage: string) {
            let dtmTrackRule = null;
            switch (dtmPage) {
                case 'cart':
                    dtmTrackRule = 'Cart_WK';
                    break;
                case 'cart-offer':
                    dtmTrackRule = 'Cart_OfferWK';
                    break;
                case 'address':
                    dtmTrackRule = 'Cart_AD';
                    break;
                case 'address-offer':
                    dtmTrackRule = 'Cart_OfferAD';
                    break;
                case 'payment':
                    dtmTrackRule = 'Cart_PP';
                    break;
                case 'summary':
                    dtmTrackRule = 'Cart_OR';
                    break;

                default:
                    break;
            }

            if (dtmTrackRule !== null) {
                try {
                    _this._satellite.track(dtmTrackRule);

                } catch (e) {

                }
            }
        }

        function dtmUpdateItems(k: string, item: Array<any>, itemCount: number) {

            if (typeof _this.digitalData.cart.item[k] !== 'undefined') {
                if (!Array.isArray(_this.digitalData.cart.item)) {
                    //console.warn('DTM - productInfo is undefined')
                    return;
                }
                if (typeof _this.digitalData.cart.item[k].productInfo === 'undefined') {
                    //console.warn('DTM - productInfo is undefined')
                    return;
                }
                if (_this.digitalData.cart.item[k].productInfo.articleId != (<any>item)[k].articleId) {
                    //console.warn('DTM - dtm.cart.articleId != item.articleId')
                    return;
                }
            }

            if(typeof _this.digitalData.cart.item[k] !== 'undefined') {
                _this.digitalData.cart.item[k].productInfo.priceList = (<any>item)[k].priceListName;
                _this.digitalData.cart.item[k].price.basePrice = ((<any>item)[k].strikeThroughArticlePrice == 0 ? (<any>item)[k].articlePrice : (<any>item)[k].strikeThroughArticlePrice);
                _this.digitalData.cart.item[k].price.voucherPrice = (<any>item)[k].articlePrice;
                _this.digitalData.cart.item[k].price.positionBasePrice = ((<any>item)[k].strikeThroughItemPrice == 0 ? (<any>item)[k].itemPrice : (<any>item)[k].strikeThroughItemPrice);
                _this.digitalData.cart.item[k].price.positionVoucherPrice = (<any>item)[k].itemPrice;
                _this.digitalData.cart.item[k].price.vat = (<any>item)[k].vatRate;
                _this.digitalData.cart.item.length = itemCount;
            }
        }

        function dtmUpdateCartPrices(cartSummaryModel: CartSummaryModel, cartItemPrices: CartItemPrice[]): void {
            // DTM set cart total values
            if (typeof _this.digitalData.cart.total === 'undefined') {
                console.warn('DTM - dtm.cart.total undefined')
                return;
            }

            _this.digitalData.cart.total = {
                possum: cartSummaryModel.netTotal,
                shipping: cartSummaryModel.handlingFee,
                voucherCode: updateVoucherCodeTracking(cartSummaryModel, cartItemPrices),
                voucherCodeDiscount: cartSummaryModel.fixAmountDiscountTotal
            };
        }

        function updateVoucherCodeTracking(cartSummaryModel: CartSummaryModel, cartItemPrices: CartItemPrice[]): Array<string> {
            if (!_this.isAnyVoucherCodeAvailable(cartSummaryModel, cartItemPrices)) return [];

            const allVoucherCodes: Array<string> = [];
            cartSummaryModel.appliedDiscounts?.forEach(discount => discount.promoCodes?.forEach(code => allVoucherCodes.push(code)));
            cartSummaryModel.missedAppliedActions?.forEach(action => allVoucherCodes.push(action.code));
            cartItemPrices.flatMap(item => item.appliedDiscounts.flatMap(discount => discount.promoCodes));

            return [...new Set(allVoucherCodes)]; // Filter duplicates
        }

        function logError(log: object) {
            async function postData(url: string, data: {}) {
                // Default options are marked with *
                const response = await fetch(url, {
                    method: 'POST', // *GET, POST, PUT, DELETE, etc.
                    mode: 'cors', // no-cors, *cors, same-origin
                    cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
                    credentials: 'same-origin', // include, *same-origin, omit
                    headers: {
                        'Content-Type': 'application/json'
                        // 'Content-Type': 'application/x-www-form-urlencoded',
                    },
                    redirect: 'follow', // manual, *follow, error
                    referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
                    body: JSON.stringify(data) // body data type must match "Content-Type" header
                });
                return response.json(); // parses JSON response into native JavaScript objects
            }

            if(_this.failedLogging < 5) {
                postData(_this.urlPrefix + '/log/', log)
                  .then(data => {
                      console.log(data); // JSON data parsed by `data.json()` call
                  });
            }
        }

        /** END DTM **/

        function updateBudgetMessage(costCenterPublicID: string) {
            if (costCenterPublicID === undefined && document.getElementById('input-field-cost-center')) {
                costCenterPublicID = (<HTMLInputElement>document.getElementById('input-field-cost-center')).value;
            }

            let uri = '/user/cost-centers/' + encodeURIComponent(costCenterPublicID);

            const priceNetTotal = document.querySelector('.price-netTotal').getAttribute('data-price-net-total');
            if (priceNetTotal !== undefined) {
                uri += '?cartAmount=' + priceNetTotal;
            }

            // $.get(uri, function (result) {
            //     document.querySelector('.budget-message').innerHTML = result;
            // });

            const httpRequest = new XMLHttpRequest()
            httpRequest.onreadystatechange = function () {
                if(document.querySelector('.budget-message')) {
                    document.querySelector('.budget-message').innerHTML = this.responseText;
                }
            }
            httpRequest.open('GET', uri)
            httpRequest.send()
        }

        if((<HTMLElement>document.querySelector('.loading-background'))) {
            helpers.fadeIn((<HTMLElement>document.querySelector('.loading-background')));
        }

        if (typeof cartType === 'undefined') { cartType = 'cart'; }

        let url = '/order/cart/price?type=' + cartType;
        if (sap === true) {
            url = url + '&withSapCalculation=true';
        }

        // TODO SSIC-251 remove me if on prod
        url = url + '&withCreditCheck=true';

        const _this = this;

        const request = new XMLHttpRequest();
        request.open('GET', url + '&disableCaching=' + new Date().getTime(), true);

        request.onload = function() {
            if (this.status >= 200 && this.status < 400) {
                var data = JSON.parse(this.responseText);

                // Cart is not purchaseable
                if (data.cartSummaryModel.notCalculable === true) {

                    let notPurchaseableCartItem = [];
                    let notPurchaseableArticles = [];

                    for (let i = 0; i < data.cartItemPrices.length; i++) {
                        if (data.cartItemPrices[i].notCalculable) {
                            for (let j = 0; j < data.cartSummaryModel.cartItems.length; j++) {
                                if (data.cartItemPrices[i].cartItemId == data.cartSummaryModel.cartItems[j].id) {
                                    if (typeof data.cartSummaryModel.cartItems[j].articleType !== 'undefined' && data.cartSummaryModel.cartItems[j].articleType != null && data.cartSummaryModel.cartItems[j].articleType.trim() !== 'GIFT') {
                                        markAsUnavailable(data.cartItemPrices[i].cartItemId, mp);
                                        notPurchaseableCartItem.push(data.cartItemPrices[i].cartItemId);
                                        notPurchaseableArticles.push(data.cartItemPrices[i].articleId);
                                    }
                                }
                            }
                        }
                    }
                    deactivateOrder();
                    // Delete not available items from Cart -- nicht mehr gewollt!
                    // window.location.href = '/order/cart/item/handle-not-available-items/?itemId=' + notPurchaseableCartItem.join(',') + '&articleId=' + notPurchaseableArticles.join(',');
                }

                // Handle articles with wrong status in pricing (catalog in b2b available, switch to b2c > this issue)
                if (data.cartSummaryModel.numberOfProducts > 0 &&
                  data.cartPurchasable === true &&
                  data.cartSummaryModel.cartItems.length !== data.cartItemPrices.length &&
                  data.cartSummaryModel.cartItems.length > data.cartItemPrices.length) {

                    for (let i = 0; i < data.cartSummaryModel.cartItems.length; i++) {
                        if (typeof data.cartItemPrices[i] === 'undefined') {
                            markAsUnavailable(data.cartSummaryModel.cartItems[i].cartItemId, mp);
                            var log = {
                                type: 'ERROR',
                                message: 'Checkout - One or more article caused an error because of a wrong status/stock. articleId: ' + data.cartSummaryModel.cartItems[i].articleId + ' | pricelist: ' + data.cartSummaryModel.cartItems[i].pricelistName + ' | isoLang: ' + data.cartSummaryModel.isoLang + ' | profile: ' + data.cartSummaryModel.profile,
                                source: 'checkout.js',
                                line: '0',
                                col: '0',
                                stack: 'null',
                                logLevel: 'vertical',
                                vertical: 'order',
                                clientLocale: '-',
                                tenant: '-',
                            };
                            logError(log);
                        }
                    }
                    deactivateOrder();
                }

                if (dtmPage == 'summary' && cartType !== 'offer') {
                    redirectToCartOrPendingCommission(data);
                }

                displayVoucherCodes(data);

                if (data.cartSummaryModel.appliedActions !== 'undefined') {
                    handleDisplayPromocode(data.cartSummaryModel.appliedActions);
                }

                if (data.cartSummaryModel.missedAppliedActions !== 'undefined') {
                    handleDisplayMissedPromocode(data.cartSummaryModel.missedAppliedActions);
                }

                if (data.cartItemPrices !== 'undefined') {
                    handleDisplayPromocodeFromItems(data.cartItemPrices);
                }

                if (data.cartSummaryModel.preliminary === true) {
                    const els: Array<HTMLElement> = Array.from(document.querySelectorAll('.basket-preliminary'));
                    els.forEach(el => el.innerHTML = 'Preis ist noch nicht gegen SAP geprüft.');
                }

                if (typeof data.cartSummaryModel.strikeThroughItemTotal !== 'undefined') {
                    // $('.price-striketroughItemTotal').html(data.cartSummaryModel.strikeThroughItemTotalFormatted);
                    const els: Array<HTMLElement> = Array.from(document.querySelectorAll('.price-striketroughItemTotal'));
                    els.forEach(el => el.innerHTML = data.cartSummaryModel.strikeThroughItemTotalFormatted);
                }

                let hasDiscount = false;
                let discountShoutbox = '';
                let discountSapShoutbox = "";
                // var totalDiscountPercentageWrapper = $('.price-totalDiscountPercentage-wrapper');
                const totalDiscountPercentageWrapper: Array<HTMLElement> = Array.from(document.querySelectorAll('.price-totalDiscountPercentage-wrapper'));
                const totalSavingsShoutboxWrapper: HTMLElement = document.querySelector('.price-totalSavingsShoutbox-wrapper');
                const totalSavingsSapShoutboxWrapper: HTMLElement = document.querySelector('.price-totalSavingsSapShoutbox-wrapper');

                if (typeof data.cartSummaryModel.appliedDiscounts !== 'undefined' && data.cartSummaryModel.appliedDiscounts.length > 0) {
                    // Total Item Rabatt
                    const discountPercentageItem = data.cartSummaryModel.totalAppliedPercentageDiscountFormatted;
                    const discountAbsoluteItem = data.cartSummaryModel.fixAmountDiscountTotalFormatted;

                    // Total Position Discount
                    if (data.cartSummaryModel.fixAmountDiscountTotal > 0) {

                        // Hide discountPercantage info if eg sap conditions and promo code are used simultaneously
                        if (discountPercentageItem && data.cartSummaryModel.itemTotalFixAmountDiscount == data.cartSummaryModel.fixAmountDiscountTotal) {
                            document.querySelector('.price-totalDiscountPercentageItems').innerHTML = ' (' + discountPercentageItem + ')' + '';
                        }
                        document.querySelector('.price-totalDiscountAbsoluteItems').innerHTML = discountAbsoluteItem;
                    } else {
                        (<HTMLElement>document.querySelector('.price-totalDiscountItems')).style.display = 'none';

                        (<HTMLElement>document.querySelector('.price-totalDiscountItems')).style.display = 'none';
                    }

                    // Total Cart Discount
                    const discountPercentageCart = data.cartSummaryModel.totalAppliedPercentageDiscountFormatted;
                    const discountAbsoluteCart = data.cartSummaryModel.totalAppliedAbsoluteDiscountFormatted;
                    if (discountAbsoluteCart) {
                        if (discountPercentageCart) {
                            document.querySelector('.price-totalDiscountPercentageCart').innerHTML = ' (-' + discountPercentageCart + ')' + '';
                            document.querySelector('.price-totalDiscountAbsoluteCart').innerHTML = discountAbsoluteCart;
                            (<HTMLElement>document.querySelector('.price-totalDiscountCart')).style.display = 'table-row';
                            discountShoutbox = discountPercentageCart;
                        } else {
                            document.querySelector('.price-totalDiscountAbsoluteCart').innerHTML = discountAbsoluteCart;
                            (<HTMLElement>document.querySelector('.price-totalDiscountCart')).style.display = 'table-row';
                            discountShoutbox = discountAbsoluteCart;
                        }

                        if (data.cartSummaryModel.itemTotalFixAmountDiscount == 0) {
                            (<HTMLElement>document.querySelector('.price-totalDiscountCart')).style.display = 'none';
                        }

                        // total with conditions over all
                        if (data.cartSummaryModel.itemFixAmountDiscountTotal > 0) {
                            discountShoutbox = data.cartSummaryModel.itemFixAmountDiscountTotalFormatted;
                        }
                        document.querySelector('.price-totalDiscountAbsoluteShoutbox').innerHTML = discountShoutbox;
                        hasDiscount = true;
                    } else {
                        hasDiscount = false;
                    }
                } else
                  // no discounts but sap conditions
                if (data.cartSummaryModel.totalAppliedAbsoluteDiscountFormatted == ''
                  && data.cartSummaryModel.itemFixAmountDiscountTotal != ''
                  && document.querySelector('.price-totalDiscountAbsoluteShoutbox')) {
                    var discountAbsolute = data.cartSummaryModel.fixAmountDiscountTotalFormatted;
                    if (discountAbsolute && document.querySelector('.price-totalDiscountAbsoluteShoutbox')) {
                        discountShoutbox = discountAbsolute;
                        document.querySelector('.price-totalDiscountAbsoluteShoutbox').innerHTML = discountShoutbox;
                        hasDiscount = true;
                    }
                } else {
                    hasDiscount = false;
                }

                // Show SAP conditions separately
                if(data.cartSummaryModel.fixAmountDiscountTotal != data.cartSummaryModel.fixAmountDiscountSapTotal
                  && data.cartSummaryModel.fixAmountDiscountSapTotal > 0
                  && document.querySelector('.price-totalDiscountSapAbsoluteShoutbox')) {
                    discountSapShoutbox = data.cartSummaryModel.fixAmountDiscountSapTotalFormatted;
                    document.querySelector('.price-totalDiscountSapAbsoluteShoutbox').innerHTML = discountSapShoutbox;
                    totalSavingsSapShoutboxWrapper.style.display = 'table-row';
                }

                // itemTotalFixAmountDiscount = discount by action with fix amount
                // itemFixAmountDiscountTotal = total discount over all

                // no amount discount (maybe only a gift / catalog)
                if (data.cartSummaryModel.itemTotalFixAmountDiscount == 0 && data.cartSummaryModel.itemFixAmountDiscountTotal == 0) {
                    // totalDiscountPercentageWrapper.css('display', 'none');
                    totalDiscountPercentageWrapper.forEach(el => el.style.display = 'none');
                    hasDiscount = false;
                } else if (data.cartSummaryModel.itemTotalFixAmountDiscount == 0 && data.cartSummaryModel.itemFixAmountDiscountTotal > 0
                  && document.querySelector('.price-totalDiscountPercentage-wrapper.price-totalDiscountCart')
                  && document.querySelector('.price-totalDiscountAbsoluteShoutbox')) {
                    // POS DISCOUNT
                    (<HTMLElement>document.querySelector('.price-totalDiscountPercentage-wrapper.price-totalDiscountCart')).style.display = 'none';

                    discountShoutbox = data.cartSummaryModel.itemFixAmountDiscountTotalFormatted;
                    document.querySelector('.price-totalDiscountAbsoluteShoutbox').innerHTML = discountShoutbox;

                    hasDiscount = true;
                } else if (data.cartSummaryModel.strikeThroughItemTotal == data.cartSummaryModel.itemTotal) {
                    // HIDE DISCOUNT (because itemTotal equals strikeThrough)
                    // totalDiscountPercentageWrapper.css('display', 'none');
                    totalDiscountPercentageWrapper.forEach(el => el.style.display = 'none');
                    hasDiscount = false;
                } else {
                    if (document.querySelector('.price-totalDiscountPercentage-wrapper.price-totalDiscountItems')) {
                        // CART DISCOUNT
                        // totalDiscountPercentageWrapper.css('display', 'block');
                        totalDiscountPercentageWrapper.forEach(el => el.style.display = 'table-row');
                        (<HTMLElement>document.querySelector('.price-totalDiscountPercentage-wrapper.price-totalDiscountItems')).style.display = 'none';
                        hasDiscount = true;
                    }
                }

                // Shoutbox
                if (hasDiscount && discountShoutbox != '' && document.querySelector('.price-totalDiscountAbsoluteCart')) {
                    const cartDiscount = document.querySelector('.price-totalDiscountAbsoluteCart').innerHTML;
                    // promo discount = total savings > hide action discount
                    if (cartDiscount == discountShoutbox) {
                        // totalDiscountPercentageWrapper.css('display', 'none');
                        totalDiscountPercentageWrapper.forEach(el => el.style.display = 'none');
                    }
                    totalSavingsShoutboxWrapper.style.display = 'table-row';
                }

                // HOTFIX HIDE AKTIONSRABATT
                totalDiscountPercentageWrapper.forEach(el => el.style.display = 'none');


                // EXISTIERT NICHT
                // $('.price-discounts').html(data.cartSummaryModel.itemTotalFormatted);

                if (typeof data.cartSummaryModel.itemTotal !== 'undefined' && document.querySelector('.price-itemTotal')) {
                    document.querySelector('.price-itemTotal').innerHTML = data.cartSummaryModel.itemTotalFormatted;
                }
                if (typeof data.cartSummaryModel.handlingFee !== 'undefined' && document.querySelector('.price-handlingFee')) {
                    document.querySelector('.price-handlingFee').innerHTML = data.cartSummaryModel.handlingFeeFormatted;
                    if(data.cartSummaryModel.handlingFee == 0 && data.cartSummaryModel.grossTotal != 0) {
                        document.querySelector('.price-handlingFee') && document.querySelector('.price-handlingFee').classList.add('fc-green');
                        if(document.getElementById('freeHandlingFee')) document.getElementById('freeHandlingFee').style.display = 'block';
                    }
                }
                if (typeof data.cartSummaryModel.trustedShopFeeFormatted !== 'undefined' && data.cartSummaryModel.trustedShopFee > 0
                  && document.querySelector('.price-trustedShopFee') && document.getElementById('trustedShopFeeInfo')) {
                    document.getElementById('trustedShopFeeInfo').style.display = '';
                    document.querySelector('.price-trustedShopFee').innerHTML = data.cartSummaryModel.trustedShopFeeFormatted;
                }
                if (typeof data.cartSummaryModel.netTotal !== 'undefined' && document.querySelector('.price-netTotal')) {
                    document.querySelector('.price-netTotal').innerHTML = data.cartSummaryModel.netTotalFormatted;
                    document.querySelector('.price-netTotal').setAttribute('data-price-net-total', data.cartSummaryModel.netTotal);
                }
                if (typeof data.cartSummaryModel.roundingFormatted !== 'undefined' && document.querySelector('.price-rounding')) {
                    document.querySelector('.price-rounding').innerHTML = data.cartSummaryModel.roundingFormatted;
                }

                var vatList = data.cartSummaryModel.vatList;
                for (let k = 0; k < vatList.length; k++) {
                    if (typeof vatList[k].percent !== 'undefined' && document.getElementById('hidden-mp-ssh-order-cart_summary-zzgl')) {
                        const mpCartSummaryZzgl = document.getElementById('hidden-mp-ssh-order-cart_summary-zzgl').textContent,
                          percent = vatList[k].percent,
                          amount = vatList[k].amountFormatted;

                        if(_this.dtmPage == 'offer-buy' && document.querySelector('.price-vatList-'+percent)) {
                            document.querySelector('.price-vatList-'+percent).innerHTML = amount;
                        } else {
                            if (document.querySelector('.price-vatlist')) {
                                document.querySelector('.price-vatlist').insertAdjacentHTML('beforeend', '<tr><th scope="row">' + mpCartSummaryZzgl + ' ' + percent + ' %</th><td>' + amount + '</td></tr>');
                            }
                        }
                    }
                }

                if (typeof data.cartSummaryModel.grossTotal !== 'undefined' && document.querySelector('.price-grossTotal')) {
                    document.querySelector('.price-grossTotal').innerHTML = data.cartSummaryModel.grossTotalFormatted;
                    if(document.querySelector('#mobileAmount')) {
                        document.querySelector('#mobileAmount').innerHTML = data.cartSummaryModel.grossTotalFormatted;
                    }
                }
                if (typeof data.cartSummaryModel.loyalityPoints !== 'undefined' && data.cartSummaryModel.loyalityPoints !== null && document.querySelector('#cart-loyalitypoints .loyalityPoints') && data.cartSummaryModel.loyalityPoints.points !== null && data.cartSummaryModel.loyalityPoints.description != '') {
                    const str = _this.mp['loyalityPoints'].replace('lpVALUE', data.cartSummaryModel.loyalityPoints.points).replace('lpNAME', data.cartSummaryModel.loyalityPoints.description);
                    document.querySelector('#cart-loyalitypoints .loyalityPoints').innerHTML = str;
                    (<HTMLInputElement>document.querySelector('#cart-loyalitypoints')).style.display = 'flex';
                }

                if (document.getElementById('input-field-cost-center') && (<HTMLInputElement>document.getElementById('input-field-cost-center')).value !== undefined && (<HTMLInputElement>document.getElementById('input-field-cost-center')).value !== '') {
                    updateBudgetMessage(undefined);
                }

                // DTM set cart total values
                dtmUpdateCartPrices(data.cartSummaryModel, data.cartItemPrices);

                // Collect and define standard articles from digitalData - no promotional article items
                let ddCartItem = [];
                if (_this.digitalData.cart && _this.digitalData.cart.item) {
                    for (let k = 0; k < _this.digitalData.cart.item.length; k++) {
                        if (typeof _this.digitalData.cart.item[k].productInfo != 'undefined' && typeof _this.digitalData.cart.item[k].productInfo.articleId != 'undefined') {
                            ddCartItem.push(_this.digitalData.cart.item[k].productInfo.articleId);
                        }
                    }
                }

                if (dtmPage == 'summary' || dtmPage == 'cart' || (dtmPage == 'address' && cartType == 'offer')) {
                    const cartItemPrices = data.cartItemPrices;
                    for (let k = 0; k < cartItemPrices.length; k++) {
                        if (typeof cartItemPrices[k].articleId !== 'undefined') {

                            const articleId = parseInt(cartItemPrices[k].articleId, 10),
                              priceListName = cartItemPrices[k].priceListName,
                              cartItemId = cartItemPrices[k].cartItemId;

                            if (cartItemPrices[k].articleParentId == null) {
                                if (document.querySelector('.article_id-' + articleId + '-' + cartItemId)) {
                                    document.querySelector('.article_id-' + articleId + '-' + cartItemId).innerHTML = articleId + '-' + priceListName.split('-')[0];
                                }

                                // Old article price: cartItemPrices[k].strikeThroughArticlePriceFormatted
                                if (typeof cartItemPrices[k].strikeThroughArticlePrice !== 'undefined' && cartItemPrices[k].strikeThroughArticlePrice > 0) {
                                    if(document.querySelector('.price-cartitem-' + cartItemId + '-articleStrikeThroughPrice')) {
                                        document.querySelector('.price-cartitem-' + cartItemId + '-articleStrikeThroughPrice').innerHTML = cartItemPrices[k].strikeThroughArticlePriceFormatted;
                                        //(<HTMLElement>document.querySelector('.price-cartitem-' + cartItemId + '-articleStrikeThroughPrice')).style.display = 'block';
                                    }

                                    if(document.querySelector('.price-cartitem-' + cartItemId + '-articlePrice')) {
                                        //document.querySelector('.price-cartitem-' + cartItemId + '-articlePrice').classList.add('fc-red');
                                    }

                                    if(document.querySelector('.price-cartitem-' + cartItemId + '-strikeThroughItemPrice')) {
                                        //document.querySelector('.price-cartitem-' + cartItemId + '-strikeThroughItemPrice').classList.add('fc-red');
                                    }

                                    // $('.basket-price-single span:first-child').css("width", "0");
                                    const els: Array<HTMLElement> = Array.from(document.querySelectorAll('.basket-price-single span:first-child'));
                                    els.forEach(el => el.style.width = '0');
                                }

                                if (typeof cartItemPrices[k].articlePrice !== 'undefined' && document.querySelector('.price-cartitem-' + cartItemId + '-articlePrice')) {
                                    document.querySelector('.price-cartitem-' + cartItemId + '-articlePrice').innerHTML = cartItemPrices[k].articlePriceFormatted;
                                }

                                if (typeof cartItemPrices[k].itemPrice !== 'undefined' && document.querySelector('.price-cartitem-' + cartItemId + '-itemPrice')) {
                                    document.querySelector('.price-cartitem-' + cartItemId + '-itemPrice').innerHTML = cartItemPrices[k].itemPriceFormatted;
                                }

                                if (typeof cartItemPrices[k].strikeThroughItemPriceFormatted !== 'undefined' && document.querySelector('.price-cartitem-' + cartItemId + '-strikeThroughItemPrice')) {
                                    document.querySelector('.price-cartitem-' + cartItemId + '-strikeThroughItemPrice').innerHTML = cartItemPrices[k].strikeThroughItemPriceFormatted;
                                }

                                if (typeof cartItemPrices[k].articleFreight !== 'undefined' && typeof cartItemPrices[k].itemFreight !== 'undefined' &&
                                  cartItemPrices[k].articleFreight > 0 && cartItemPrices[k].itemFreight > 0) {
                                    if(document.querySelector('.price-cartitem-' + cartItemId + '-freightArticlePrice')) {
                                        document.querySelector('.price-cartitem-' + cartItemId + '-freightArticlePrice').innerHTML = '&nbsp;';
                                    }
                                    if(document.querySelector('.price-cartitem-' + cartItemId + '-absoluteFreightArticlePrice')) {
                                        document.querySelector('.price-cartitem-' + cartItemId + '-absoluteFreightArticlePrice').innerHTML = cartItemPrices[k].itemFreightFormatted;
                                    }
                                    const els: Array<HTMLElement> = Array.from(document.querySelectorAll('.basket-price-freight-' + cartItemId));
                                    els.forEach(el => el.style.display = 'block');
                                }

                                if (typeof cartItemPrices[k].appliedDiscounts !== 'undefined' && cartItemPrices[k].appliedDiscounts.length > 0) {
                                    const discountPercentage = cartItemPrices[k].totalAppliedPercentageDiscountFormatted;
                                    const discountAbsolute = cartItemPrices[k].totalAppliedAbsoluteDiscountFormatted;

                                    // Show only if percentage discount, not absolute amount
                                    // if we need to diplay fix amounts, the fix amount has to be displayed BEFORE the sap discount (in html!)

                                    if (discountPercentage) {
                                        document.querySelector('.price-cartitem-' + cartItemId + '-percentageAmountDiscount').innerHTML = '-' + discountPercentage;
                                        document.querySelector('.price-cartitem-' + cartItemId + '-absoluteAmountDiscount').innerHTML = '-' + discountAbsolute;
                                        const els: Array<HTMLElement> = Array.from(document.querySelectorAll('.basket-price-condition-amount-' + cartItemId));
                                        els.forEach(el => el.style.display = 'block');
                                    } else {
                                        document.querySelector('.price-cartitem-' + cartItemId + '-absoluteAmountDiscount').innerHTML = '-' + discountAbsolute;
                                        const els: Array<HTMLElement> = Array.from(document.querySelectorAll('.basket-price-condition-amount-' + cartItemId));
                                        els.forEach(el => el.style.display = 'block');
                                    }
                                } else {
                                    const discountAbsolute = cartItemPrices[k].articleFixAmountDiscountFormatted;
                                    if (cartItemPrices[k].articleFixAmountDiscount > 0) {
                                        const AmountDiscount = document.querySelector('.price-cartitem-' + cartItemId + '-absoluteAmountDiscount');
                                        AmountDiscount && (AmountDiscount.innerHTML = '-' + discountAbsolute);
                                        const els: Array<HTMLElement> = Array.from(document.querySelectorAll('.basket-price-condition-amount-' + cartItemId));
                                        els.forEach(el => el.style.display = 'block');
                                    }
                                }

                                if (typeof cartItemPrices[k].appliedSapDiscounts !== 'undefined' && cartItemPrices[k].appliedSapDiscounts.length > 0) {
                                    const sapDiscountPercentage = cartItemPrices[k].totalAppliedPercentageSapDiscountFormatted;
                                    const sapDiscountAbsolute = cartItemPrices[k].totalAppliedAbsoluteSapDiscountFormatted;
                                    document.querySelector('.price-cartitem-' + cartItemId + '-sapPercentageAmountDiscount').innerHTML = '-' + sapDiscountPercentage;
                                    document.querySelector('.price-cartitem-' + cartItemId + '-sapAbsoluteAmountDiscount').innerHTML = '-' + sapDiscountAbsolute;
                                    const els: Array<HTMLElement> = Array.from(document.querySelectorAll('.basket-sap-condition-' + cartItemId));
                                    els.forEach(el => el.style.display = 'block');
                                    document.querySelector('.price-totalDiscountPercentageItems').innerHTML = ' (-' + sapDiscountPercentage + ')' + '';

                                    // Hide e.g. catalog and gifts
                                    if (typeof data.cartSummaryModel.cartItems[k].articleType !== 'undefined') {
                                        if (data.cartSummaryModel.cartItems[k].articleType != 'STANDARD' && data.cartSummaryModel.cartItems[k].articleType != 'FAMILYCHILD') {
                                            els.forEach(el => el.style.display = 'none');
                                        }
                                    }
                                }

                                // Leave this here - after all discounts are hidden or shown check this again
                                // if (typeof cartItemPrices[k].strikeThroughArticlePrice !== 'undefined'
                                //     && cartItemPrices[k].strikeThroughArticlePrice > 0
                                //     && (typeof cartItemPrices[k].appliedDiscounts === 'undefined' || cartItemPrices[k].appliedDiscounts.length == 0)) {
                                //     (<HTMLElement>document.querySelector('.basket-price-single.basket-price-condition-amount-' + cartItemId)).style.display = 'none';
                                //     (<HTMLElement>document.querySelector('.basket-price-sum.basket-price-condition-amount-' + cartItemId)).style.display = 'none';
                                // }

                            } else {
                                let configurationPriceElementClass;
                                switch (articleId) {
                                    case 398:
                                        configurationPriceElementClass = "production_cost"
                                        break;

                                    case 318:
                                        configurationPriceElementClass = "setup_cost"
                                        break;

                                    case 321:
                                        configurationPriceElementClass = "global_additional_logo_costs"
                                        break;

                                    case 324:
                                        configurationPriceElementClass = "global_korrekturmuster"
                                        break;

                                    case 304: // Not available/visible on QAD
                                        configurationPriceElementClass = "global_korrekturabzug"
                                        break;

                                    default:
                                        break;
                                }
                                const configurationArticlePriceElement = document.querySelector('.price-cartitem-' + cartItemId + '-advertising-' + configurationPriceElementClass);
                                const configurationArticleDescriptionElement = document.querySelector('.cartItem-articleDescription-' + cartItemId + '-' + configurationPriceElementClass);
                                const absoluteConfigurationArticlePriceElement = document.querySelector('.price-cartitem-' + cartItemId + '-absolute-advertising-' + configurationPriceElementClass);

                                // SinglePrice
                                if (typeof configurationArticlePriceElement !== "undefined" && typeof cartItemPrices[k].articlePriceFormatted !== 'undefined') {
                                    configurationArticlePriceElement.innerHTML = cartItemPrices[k].articlePriceFormatted;
                                }
                                // Sum
                                if (typeof absoluteConfigurationArticlePriceElement !== "undefined" && typeof cartItemPrices[k].itemPriceFormatted !== 'undefined') {
                                    absoluteConfigurationArticlePriceElement.innerHTML = cartItemPrices[k].itemPriceFormatted;
                                }

                                // Configuration Article Description by ArticleId
                                const configurationPriceSumElements: Array<HTMLElement> = Array.from(document.querySelectorAll('.configuration-' + cartItemId + '-advertising-' + configurationPriceElementClass));
                                configurationPriceSumElements.forEach(el => el.style.display = 'block');
                            }

                            // DTM set item values after ajax call
                            if (ddCartItem.indexOf(cartItemPrices[k].articleId) != -1) {
                                dtmUpdateItems(k.toString(), cartItemPrices, ddCartItem.length);
                            }
                        }
                    }
                }


                // Check if promo article is in cart
                const cartItems = data.cartSummaryModel.cartItems;
                let cartHasPromotionArticles = false;
                if (cartItems) {
                    for (let k = 0; k < cartItems.length; k++) {
                        if (typeof cartItems[k].configurationHash !== 'undefined' && cartItems[k].configurationHash != null) {
                            cartHasPromotionArticles = true;
                        }
                    }
                }

                if (cartHasPromotionArticles) {
                    _this.disableProfileSwitches('modal-profile-switch-hint-promoInCart');
                }

                // edge case: reload if new gifts are set and not shown yet
                // var countArticlesOnCart = $(".article-entry");
                const countArticlesOnCart: Array<HTMLElement> = Array.from(document.querySelectorAll('.article-entry'));
                const domArticleIds = countArticlesOnCart.map(function (el) {
                    // return $(this).data("order-cart-article-id")
                    return el.getAttribute('data-order-cart-article-id')
                })

                //gift should be there but is not (giftid = yes, but not in dom)
                let shouldReload = false;
                if (data.cartSummaryModel.giftIds.length > 0) {
                    for (let i = 0; i < data.cartSummaryModel.giftIds.length; i++) {
                        var giftId = data.cartSummaryModel.giftIds[i];
                        var contains = false;
                        for (let k = 0; k < domArticleIds.length; k++) {
                            const curDomArticleId = domArticleIds[k];
                            if (typeof curDomArticleId === 'string' && curDomArticleId === giftId) {
                                // $(".article-entry[data-order-cart-article-id='" + curDomArticleId + "']").find('.order-cart-article-quantity').remove();
                                const els: Array<HTMLElement> = Array.from(
                                  document.querySelectorAll('.article-entry[data-order-cart-article-id="' + curDomArticleId + '"] .order-cart-article-quantity')
                                );
                                els.forEach(el => el.remove());
                                contains = true;
                            }
                        }
                        if (!contains && countArticlesOnCart.length > 0) {
                            shouldReload = true;
                            if(typeof giftId == 'string' || typeof giftId == 'number') {
                                // $.getJSON(urlPrefix + "/product/article/" + giftId).done(function (response) {
                                //     var article = response[0];
                                //     renderArticleToCart(article);
                                // }).fail(function () {
                                //
                                // });

                                const request = new XMLHttpRequest();
                                request.open('GET', _this.urlPrefix + '/product/article/' + giftId, true);

                                request.onload = function() {
                                    if (request.status >= 200 && request.status < 400) {
                                        const data = JSON.parse(request.responseText);

                                        const article = data[0];
                                        _this.renderArticleToCart(article);
                                    } else {
                                    }
                                };
                                request.onerror = function() {
                                };
                                request.send();
                            }
                        }
                    }
                }


                /*
                        $.getJSON(urlPrefix + "/product/article/1090122").done(function (response) {
                            var article = response[0];
                            renderArticleToCart(article);
                        }).fail(function () {

                        });
                */

                if (cartItems) {
                    //gift should be removed but is not
                    for (let k = 0; k < cartItems.length; k++) {
                        if (typeof cartItems[k].articleType !== 'undefined' && cartItems[k].articleType != null && cartItems[k].articleType.trim() == 'GIFT') {
                            let hasGift = false;


                            for (let i = 0; i < data.cartSummaryModel.giftIds.length; i++) {
                                const giftId = data.cartSummaryModel.giftIds[i];
                                if (giftId == cartItems[k].articleId) {
                                    hasGift = true;
                                }
                            }

                            if (!hasGift) {
                                document.querySelector('.article-entry[data-order-cart-article-id="' + cartItems[k].articleId + '"]').remove();

                                shouldReload = true;
                            }
                        }
                    }
                }

                if (shouldReload) {
                    location.reload();
                } else {
                    setTimeout(() => {
                        if((<HTMLElement>document.querySelector('.loading-background'))) {
                            helpers.fadeOut(document.querySelector('.loading-background'));
                        }
                    }, 500);

                    if (document.querySelector('.step-current')) {
                        document.querySelector('.step-current').scrollIntoView({ behavior: 'smooth', block: 'start'});
                    }

                    _this.handleSummaryWidget();

                    if (typeof data.cartPurchasable !== 'undefined') {
                        if (data.cartPurchasable == true) {
                            if (cartHasPromotionArticles && data.cartSummaryModel.sapTimeout) {
                                // $(".modal-background").fadeIn('200');
                                helpers.fadeIn((<HTMLElement>document.querySelector('.modal-background')));
                                // $("#modal-promotion-article-sap-failed").fadeIn('200').css('display', 'block');
                                helpers.fadeIn(document.getElementById('modal-promotion-article-sap-failed'));

                                if (document.querySelector('.toggle-proceed-checkout') || document.querySelector('.standard-offer')) {
                                    let buttons = document.querySelectorAll('.toggle-proceed-checkout, .standard-offer');
                                    buttons = [].slice.call(buttons);
                                    buttons.forEach( (button:HTMLButtonElement) => {
                                        _this.disableButton(button);
                                    })
                                }
                            } else {
                                if (document.querySelector('.toggle-proceed-checkout') || document.querySelector('.standard-offer')) {
                                    let buttons = document.querySelectorAll('.toggle-proceed-checkout, .standard-offer');
                                    buttons = [].slice.call(buttons);
                                    buttons.forEach( (button:HTMLButtonElement) => {
                                        _this.enableButton(button);
                                    })
                                }
                            }
                        } else {
                            if (document.querySelector('.toggle-proceed-checkout') || document.querySelector('.standard-offer')) {
                                let buttons = document.querySelectorAll('.toggle-proceed-checkout, .standard-offer');
                                buttons = [].slice.call(buttons);
                                buttons.forEach( (button:HTMLButtonElement) => {
                                    _this.disableButton(button);
                                })
                            }
                        }
                    }

                    // DTM execute updated dtm-json
                    dtmUpdateTracking(dtmPage);

                    // INSURANCE
                    if(document.querySelector('.intangibleInsuranceToggle') && document.querySelector('.intangibleInsuranceToggle').getAttribute('data-state') == 'true') {
                        _this.insurancePushCart(data.cartItemPrices);
                    }


                    // CreditStatus after DTM
                    const creditStatus = data.cartSummaryModel.creditStatus;
                    const eligibleByCreditStatus = data.cartSummaryModel.eligibleByCreditStatus;

                    // init payment bonity check
                    let paymentCreditStatusCheck = false;

                    if (dtmPage == 'cart') {
                        document.querySelector('.toggle-proceed-checkout').setAttribute('data-credit-status', eligibleByCreditStatus);
                    }
                    if (dtmPage == 'payment' || dtmPage == 'payment-pending' || dtmPage == 'offer-buy') {
                        let paymentName;
                        if(document.querySelector('.active-payment-method')) {
                            paymentName = document.querySelector('.active-payment-method').getAttribute('data-payment-name');
                        }
                        if (typeof paymentName === 'undefined') paymentName = false;

                        //paymentCreditStatusCheck = $('.checkout-payment-' + paymentName).data('payment-creditstatus-check');
                        if (document.querySelector('.checkout-payment-' + paymentName)) {
                            paymentCreditStatusCheck = document.querySelector('.checkout-payment-' + paymentName).getAttribute('data-payment-creditstatus-check') == 'true';
                        }

                        // Deactivate payment methods
                        if (eligibleByCreditStatus === false) {
                            _this.rejectPayments();
                            if(paymentCreditStatusCheck === true) {
                                if(_this.dtmPage == 'offer-buy') {
                                    _this.disableButton(document.querySelector('.toggle-buy-offer'));
                                } else if(_this.dtmPage == 'payment-pending') {
                                    _this.disableButton(document.querySelector('.toggle-pay-again'));
                                } else {
                                    _this.disableButton(document.querySelector('.toggle-to-summary'));
                                }
                            }
                        }

                        if (paymentName !== false) {
                            if (eligibleByCreditStatus === true || paymentCreditStatusCheck === false) {

                                if(_this.dtmPage == 'offer-buy') {
                                    _this.enableButton(document.querySelector('.toggle-buy-offer'));
                                } else if(_this.dtmPage == 'payment-pending') {
                                    _this.enableButton(document.querySelector('.toggle-pay-again'));
                                } else {
                                    _this.enableButton(document.querySelector('.toggle-to-summary'));
                                }
                            }
                        }
                    }

                    if (dtmPage == 'summary' && cartType !== 'offer') {
                        // $('#creditStatus').attr('data-state', creditStatus);
                        // $('#creditStatus').attr('data-validation', eligibleByCreditStatus);
                        document.getElementById('creditStatus').setAttribute('data-state', creditStatus);
                        document.getElementById('creditStatus').setAttribute('data-validation', eligibleByCreditStatus);
                    }
                }

                if(data?.cartSummaryModel?.cartItems?.length > 0 && data?.cartPurchasable === false) {
                    const notBuyableItemsInfo = document.querySelector('.not-buyable-items-info');
                    notBuyableItemsInfo?.classList.remove('hidden');
                }

            } else {
                if (_this.cartPricesUpdated === 0) {
                    _this.cartPricesUpdated = _this.cartPricesUpdated + 1;
                    _this.updateCartPrices(cartType, false, dtmPage, mp);
                } else {
                    if((<HTMLElement>document.querySelector('.loading-background'))) {
                        helpers.fadeOut(document.querySelector('.loading-background'));
                    }
                    // $(".modal-background").fadeIn('200');
                    helpers.fadeIn((<HTMLElement>document.querySelector('.modal-background')));
                    // $("#modal-failed-cartprice").fadeIn('200');
                    helpers.fadeIn(document.getElementById('modal-failed-cartprice'));

                    _this.handleSummaryWidget();
                }
            }
        };

        request.onerror = function() {
            console.log('error');
        };
        request.send();

        domReady(function () {
            if (document.querySelector('.toggle-to-checkout')) {
                document.querySelector('.toggle-to-checkout').addEventListener('click', function() {
                    _this.disableButton(this);
                })
            }

            // WW Shop Checkbox Check
            if (document.getElementById('input-field-offer-terms')) {
                _this.disableButton(document.querySelector('#cart_summary .toggle-proceed-offer'));
                document.getElementById('input-field-offer-terms').addEventListener('change', function() {
                    (<HTMLInputElement>this).checked ? _this.enableButton(document.querySelector('#cart_summary .toggle-proceed-offer')) : _this.disableButton(document.querySelector('#cart_summary .toggle-proceed-offer'));
                })
            }

            // $("#input-field-cost-center").change(function () {
            //     submitOrderDetails(this.name, this.value);
            //     updateBudgetMessage(this.value);
            // });

            if (document.getElementById('input-field-cost-center')) {
                let costCenterInputs = document.querySelectorAll('#dropdown-input-field-cost-center li');

                costCenterInputs.forEach((costCenterInput: HTMLElement) => {
                    costCenterInput.addEventListener('click', () => {
                        const costCenterPublicId = costCenterInput.getAttribute('data-value');
                        let costCenterValue = costCenterPublicId;
                        // Check for colon until all verticals only use publicId
                        if(!costCenterPublicId.includes(':')) {
                            costCenterValue = costCenterPublicId + ':' + costCenterInput.textContent;
                        }
                        _this.submitOrderDetails('costCenter', costCenterValue);
                        updateBudgetMessage(costCenterPublicId);
                    });
                });


                /*(<HTMLInputElement>document.getElementById('input-field-cost-center')).addEventListener('change', () => {

                    console.log('input-field-cost-center change');
                    _this.submitOrderDetails(this.name, this.value);
                    updateBudgetMessage(this.value);
                })*/
            }
        });
    }

    getFtlData() {
        const _this = this;

        _this.mp = {};

        const dataElement: HTMLElement = document.getElementById('ftlData') || null;
        let sap: boolean;

        if(dataElement && dataElement.getAttribute('data-sap')) {
            dataElement.getAttribute('data-sap') == '0' ? sap = false : sap = true;
        }
        if(dataElement && dataElement.getAttribute('data-cartType')) {
            _this.cartType = dataElement.getAttribute('data-cartType');
        }
        if(dataElement && dataElement.getAttribute('data-dtmPage')) {
            _this.dtmPage = dataElement.getAttribute('data-dtmPage');
        }

        let mpElements: Array<HTMLElement>;
        if(dataElement) {
            mpElements = Array.from(dataElement.querySelectorAll('[data-mp]'));
            mpElements.forEach(mpEl => {
                _this.mp[mpEl.getAttribute('data-mp')] = mpEl.innerHTML;
            })
        }


        windowLoaded(function() {
            _this.digitalData = (<any>window)['digitalData'];
            _this._satellite = (<any>window)['_satellite'];
            _this.disableProfileSwitches = (<any>window)['disableProfileSwitches'];
            _this.renderArticleToCart = (<any>window)['renderArticleToCart'];
            _this.insurancePushCart = (<any>window)['insurancePushCart'];
            _this.rejectPayments = (<any>window)['rejectPayments'];
            _this.urlPrefix = (<any>window)['urlPrefix'];

            if(_this.dtmPage == 'cart') {
                const mobileSummary = document.getElementById('summary-mobile');
                const cartBenefits = document.getElementById('cartBenefits');

                if(window.innerWidth <= 990) {
                    mobileSummary && mobileSummary.parentNode.insertBefore(document.getElementById('cart_summary_wrapper'), mobileSummary.nextSibling);
                } else {
                    cartBenefits && cartBenefits.parentNode.insertBefore(document.getElementById('cart_summary_wrapper'), cartBenefits);
                }


                // TODO: rework resize listener for discount code
                // window.addEventListener('resize', function() {
                //     if(window.innerWidth <= 990) {
                //         mobileSummary && mobileSummary.parentNode.insertBefore(document.getElementById('cart_summary_wrapper'), mobileSummary.nextSibling);
                //     } else {
                //         cartBenefits && cartBenefits.parentNode.insertBefore(document.getElementById('cart_summary_wrapper'), cartBenefits);
                //     }
                // })
            }

            if(_this.dtmPage == 'payment' || _this.dtmPage == 'payment-pending' || _this.dtmPage == 'offer-buy') {
                var paymentCreditStatusCheck;

                if (document.querySelector('.active-payment-method')) {
                    paymentCreditStatusCheck = document.querySelector('.active-payment-method').getAttribute('data-payment-creditstatus-check');
                } else {
                    paymentCreditStatusCheck = false;
                }

                if (paymentCreditStatusCheck == 'true') {
                    if(_this.dtmPage == 'offer-buy') {
                        _this.enableButton(document.querySelector('.toggle-buy-offer'));
                    } else if(_this.dtmPage == 'payment-pending') {
                        _this.enableButton(document.querySelector('.toggle-pay-again'));
                    } else {
                        _this.enableButton(document.querySelector('.toggle-to-summary'));
                    }
                }
            }

            if(_this.dtmPage == 'cart' || _this.dtmPage == 'cart-offer' || _this.dtmPage == 'address' || _this.dtmPage == 'address_pdf'  || _this.dtmPage == 'address-offer' || _this.dtmPage == 'payment' || _this.dtmPage == 'payment-pending' || _this.dtmPage == 'summary' || _this.dtmPage == 'offer-buy') {

                if(_this.dtmPage != 'offer-buy' && _this.dtmPage != 'payment-pending' ) {
                    _this.updateCartPrices(_this.cartType, sap, _this.dtmPage, _this.mp)
                } else {
                    _this.handleSummaryWidget();
                }

                if(_this.dtmPage == 'address' && _this.cartType == 'offer' && document.querySelector('.offerSign')) {
                    (<HTMLInputElement>document.querySelector('.offerSign')).addEventListener('blur', function() {
                        const XHR = new XMLHttpRequest()
                        XHR.open('POST', '/order/offer/orderSignToCart')
                        XHR.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8')
                        XHR.setRequestHeader('X-Requested-With', 'XMLHttpRequest')
                        XHR.send(this.name + '=' + this.value + '&type=offer');
                    })
                }

                if(_this.dtmPage == 'summary') {
                    const els: Array<HTMLInputElement> = Array.from(
                      document.querySelectorAll('.commit-on-blur')
                    );
                    els.forEach(el => el.addEventListener('blur', function () {
                        _this.submitOrderDetails(this.name, this.value)
                    }));

                    const formEvo = document.querySelector('.form-buynow-evopay');

                    if(formEvo) {
                        formEvo.addEventListener('submit', function(e) {
                            e.preventDefault();

                            const formInputs = Array.from(formEvo.querySelectorAll('input'));

                            let serialString = '';
                            formInputs.forEach((input, index) => {
                                serialString += encodeURIComponent(input.name) + '=' + encodeURIComponent(input.value.toString());
                                ++index < formInputs.length ? serialString += '&' : null;
                            })

                            const XHR = new XMLHttpRequest();
                            XHR.open('POST', formEvo.getAttribute('action'));
                            XHR.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
                            XHR.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
                            XHR.onload = function () {
                                if (XHR.readyState === 4 && XHR.status === 200) {
                                    if (XHR.getResponseHeader('x-http-evo-redirect')) {
                                        const newUrl = "${baseUrl}" + XHR.getResponseHeader('x-http-evo-redirect');
                                        window.location.replace(newUrl);
                                    } else {
                                        document.getElementById('evopay-response').innerHTML = XHR.response;
                                        (<HTMLFormElement>document.getElementById('evoForm')).submit();
                                    }
                                }
                            }
                            XHR.send(serialString);
                        });
                    }
                }
                if(_this.dtmPage == 'payment-pending' || _this.dtmPage == 'offer-buy') {
                    if (document.querySelector('.step-current')) {
                        document.querySelector('.step-current').scrollIntoView({ behavior: 'smooth', block: 'start'});
                    }

                    const form = document.getElementById('form-checkout-payment');

                    form.addEventListener('submit', function(e) {

                        const selectedPaymentName = document.querySelector('.block-checkout-payment .active-payment-method').getAttribute('data-payment-name');

                        if (selectedPaymentName == 'idealByEvo' || selectedPaymentName == 'evo-payments') {
                            e.preventDefault();

                            const formInputs = Array.from(form.querySelectorAll('input[type="radio"]:checked, input[type="text"]'));

                            let serialString = '';
                            formInputs.forEach((input:HTMLInputElement, index) => {
                                serialString += encodeURIComponent(input.name) + '=' + encodeURIComponent(input.value.toString());
                                ++index < formInputs.length ? serialString += '&' : null;
                            })

                            const XHR = new XMLHttpRequest();
                            XHR.open('POST', form.getAttribute('action'));
                            XHR.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
                            XHR.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
                            XHR.onload = function () {
                                if (XHR.readyState === 4 && XHR.status === 200) {
                                    if (XHR.getResponseHeader('x-http-evo-redirect')) {
                                        const newUrl = "${baseUrl}" + XHR.getResponseHeader('x-http-evo-redirect');
                                        window.location.replace(newUrl);
                                    } else {
                                        var doc = new DOMParser().parseFromString(XHR.response, "text/html");
                                        var evoForm = doc.body.childNodes;
                                        for (var i = 0; i < evoForm.length; i++) {
                                            document.getElementById('evopay-response').appendChild(evoForm[i])
                                        }
                                        (<HTMLFormElement>document.getElementById('evoForm')).submit();
                                    }
                                }
                            }
                            XHR.send(serialString);
                        }
                    });
                }
            }
            if(_this.dtmPage == 'confirmation') {
                _this.handleConfirmation();
            }
        })
    }

    handleConfirmation() {
        const _this = this;

        domReady( function () {
            const createWishlist = document.getElementById('createWishlist');
            if(createWishlist) {
                createWishlist.style.width = createWishlist.getBoundingClientRect().width + 'px';
                createWishlist.addEventListener('click', (e) => {
                    const XHR = new XMLHttpRequest();
                    let w1 = createWishlist.querySelector('.mp-done').getBoundingClientRect().width,
                      w2 = createWishlist.querySelector('.mp-pending').getBoundingClientRect().width;
                    if(w1 > w2) {
                        createWishlist.style.width = createWishlist.getBoundingClientRect().width + (w1 - w2) + 'px';
                    }

                    XHR.open( 'POST', _this.urlPrefix + '/order/checkout/confirmation/'+ createWishlist.getAttribute('data-commissionSub') +'/wishlist' );
                    XHR.setRequestHeader('X-Requested-With', 'XMLHttpRequest')
                    XHR.onload = () => {
                        const response = XHR.getResponseHeader('location');

                        if (XHR.readyState == 4 && XHR.status == 201) {
                            const linkToWishlist = document.createElement('a');
                            linkToWishlist.href = response;
                            linkToWishlist.classList.add('arrowlink');
                            linkToWishlist.textContent = createWishlist.parentElement.dataset.wishlistLink;
                            createWishlist.parentElement.parentNode.insertBefore(linkToWishlist, createWishlist.parentElement.nextSibling);
                            (<HTMLButtonElement>document.getElementById('createWishlist')).disabled = true;
                            setTimeout(() => {
                                createWishlist.classList.add('wishlist--created');
                            }, 1400);
                        }
                    }
                    XHR.send();

                    e.preventDefault();
                })
            }
        })
    }

    handleSummaryWidget() {
        domReady(function () {
            const cartSummary = document.getElementById('cart_summary_wrapper'),
              checkoutSteps = document.getElementById('checkout_steps') || document.getElementById('checkout_main'),
              aside = (<HTMLElement>document.querySelector('.checkout aside')),
              cartBenefits = document.getElementById('cartBenefits');

            let sticky = window.pageYOffset + cartSummary.getBoundingClientRect().top;
            // offset if default header being used (instead of checkout header)
            if(document.getElementsByTagName('header')[0].classList.contains('head')) {
                sticky -= 98;
            }

            let windowWidth: number = window.innerWidth;
            let scrollingActive: boolean = windowWidth >= 1280;

            window.addEventListener('resize', function () {
                windowWidth = window.innerWidth;
                scrollingActive = windowWidth >= 1280;

                if (!scrollingActive) {
                    aside.style.transform = 'translateY(0px)';
                    cartBenefits && cartBenefits.classList.remove('js--hide');
                }
            })

            function scrollSummary() {
                const topOffset = window.pageYOffset,
                  cartSummaryHeight = cartSummary.offsetHeight,
                  checkoutStepsHeight = checkoutSteps.offsetHeight,
                  maxTopOffset = checkoutStepsHeight - cartSummaryHeight;

                if (scrollingActive) {
                    if (checkoutStepsHeight > cartSummaryHeight*2) {
                        if (window.pageYOffset < checkoutStepsHeight - cartSummaryHeight + sticky - 20 && window.pageYOffset >= sticky + cartSummaryHeight) {
                            aside.style.transform = 'translateY('+ ( topOffset - sticky + 20 ) +'px)';
                            cartBenefits && cartBenefits.classList.add('js--hide');
                        } else if (window.pageYOffset < sticky + cartSummaryHeight) {
                            aside.style.transform = 'translateY(0px)';
                            cartBenefits && cartBenefits.classList.remove('js--hide');
                        } else {
                            aside.style.transform = 'translateY('+ maxTopOffset +'px)';
                            cartBenefits && cartBenefits.classList.add('js--hide');
                        }
                    } else {
                        aside.style.transform = 'translateY(0px)';
                        cartBenefits && cartBenefits.classList.remove('js--hide');
                    }
                }
            }
            scrollSummary();

            window.addEventListener('scroll', scrollSummary);
        })
    }

    rejectPayments() {
        /**
         * bonity check
         */
          // show info text for selected payment (active) and reject all payments with bonity check
        const formCheckoutPayment = document.querySelector('#form-checkout-payment');
        const creditStatus = formCheckoutPayment.querySelectorAll('[data-payment-creditstatus-check="true"]');
        creditStatus.forEach((el) => {
            const paymentName = el.getAttribute('data-payment-name');
            formCheckoutPayment.querySelectorAll('.form-field-input-checkbox.checkout-payment-' + paymentName).forEach(e => e.parentNode.removeChild(e));
            formCheckoutPayment.querySelectorAll('.checkmark.checkout-payment-' + paymentName).forEach(e => e.parentNode.removeChild(e));
            formCheckoutPayment.querySelectorAll('.payment-info-box-' + paymentName).forEach(e => e.parentNode.removeChild(e));
            formCheckoutPayment.querySelectorAll('.checkout-payment-' + paymentName).forEach(e => {
                const classes = ['active', 'active-payment-method', 'checkout-payment-' + paymentName + '-toggle payment-method-element'];
                e.classList.remove(...classes);
                e.classList.add('disabled');
            });
        });
        // Hide additional forms
        formCheckoutPayment.querySelectorAll('#form-directDebit, #form-ideal').forEach((e: HTMLElement) => e.style.display = 'none');
    }

    paymentMethods() {
        const _this = this;
        /**
         * remove spaces from IBAN
         */
        const form = document.querySelector('#form-checkout-payment');
        if (form !== null) {
            const inputFieldIban: HTMLInputElement = document.querySelector('#input-field-iban');

            if (inputFieldIban !== null) {
                inputFieldIban.addEventListener('change', () => {
                    let str = inputFieldIban.value;
                    str = str.replace(/\s+/g, '');
                    inputFieldIban.value = str;
                });
            }

            /**
             * click on any payment
             */
            let paymentMethodElements = document.querySelectorAll('.payment-method-element');
            paymentMethodElements = [].slice.call(paymentMethodElements);

            paymentMethodElements.forEach((element: HTMLElement) => {
                element.addEventListener('click', () => {
                    if (!element.classList.contains('disabled')) {
                        form.querySelectorAll('#form-directDebit, #form-ideal').forEach((e: HTMLElement) => e.style.display = 'none');
                        paymentMethodElements.forEach((el) => {
                            el.classList.remove(...['active', 'active-payment-method']);
                        });
                        setTimeout(() => {
                            element.classList.add(...['active', 'active-payment-method']);
                            if(_this.dtmPage == 'offer-buy') {
                                _this.enableButton(document.querySelector('.toggle-buy-offer'));
                            } else if(_this.dtmPage == 'payment-pending') {
                                _this.enableButton(document.querySelector('.toggle-pay-again'));
                            } else {
                                _this.enableButton(document.querySelector('.toggle-to-summary'));
                            }
                        }, 100);
                    }
                });
            });

            /**
             * toggle direct debit
             */
            const directDebitToggle = form.querySelector('.checkout-payment-directDebit-toggle');
            if (directDebitToggle) {
                directDebitToggle.addEventListener('click', (el: any) => {
                    if (!el.target.classList.contains('disabled')) {
                        (<HTMLElement>form.querySelector('#form-directDebit')).style.display = 'block';
                    }
                });
            }

            /**
             * toggle ideal
             */
            const idealByEvoToggle = form.querySelector('.checkout-payment-idealByEvo-toggle');
            if (idealByEvoToggle) {
                idealByEvoToggle.addEventListener('click', (el: any) => {
                    if (!el.target.classList.contains('disabled')) {
                        (<HTMLElement>form.querySelector('#form-ideal')).style.display = 'block';
                    }
                });
            }
        }

        /**
         * validate IBAN
         */
        function checkIban(field: string) {
            const pattern = /^AL\d{10}[0-9A-Z]{16}$|^AD\d{10}[0-9A-Z]{12}$|^AT\d{18}$|^BH\d{2}[A-Z]{4}[0-9A-Z]{14}$|^BE\d{14}$|^BA\d{18}$|^BG\d{2}[A-Z]{4}\d{6}[0-9A-Z]{8}$|^HR\d{19}$|^CY\d{10}[0-9A-Z]{16}$|^CZ\d{22}$|^DK\d{16}$|^FO\d{16}$|^GL\d{16}$|^DO\d{2}[0-9A-Z]{4}\d{20}$|^EE\d{18}$|^FI\d{16}$|^FR\d{12}[0-9A-Z]{11}\d{2}$|^GE\d{2}[A-Z]{2}\d{16}$|^DE\d{20}$|^GI\d{2}[A-Z]{4}[0-9A-Z]{15}$|^GR\d{9}[0-9A-Z]{16}$|^HU\d{26}$|^IS\d{24}$|^IE\d{2}[A-Z]{4}\d{14}$|^IL\d{21}$|^IT\d{2}[A-Z]\d{10}[0-9A-Z]{12}$|^[A-Z]{2}\d{5}[0-9A-Z]{13}$|^KW\d{2}[A-Z]{4}22!$|^LV\d{2}[A-Z]{4}[0-9A-Z]{13}$|^LB\d{6}[0-9A-Z]{20}$|^LI\d{7}[0-9A-Z]{12}$|^LT\d{18}$|^LU\d{5}[0-9A-Z]{13}$|^MK\d{5}[0-9A-Z]{10}\d{2}$|^MT\d{2}[A-Z]{4}\d{5}[0-9A-Z]{18}$|^MR13\d{23}$|^MU\d{2}[A-Z]{4}\d{19}[A-Z]{3}$|^MC\d{12}[0-9A-Z]{11}\d{2}$|^ME\d{20}$|^NL\d{2}[A-Z]{4}\d{10}$|^NO\d{13}$|^PL\d{10}[0-9A-Z]{,16}n$|^PT\d{23}$|^RO\d{2}[A-Z]{4}[0-9A-Z]{16}$|^SM\d{2}[A-Z]\d{10}[0-9A-Z]{12}$|^SA\d{4}[0-9A-Z]{18}$|^RS\d{20}$|^SK\d{22}$|^SI\d{17}$|^ES\d{22}$|^SE\d{22}$|^CH\d{7}[0-9A-Z]{12}$|^TN59\d{20}$|^TR\d{7}[0-9A-Z]{17}$|^AE\d{21}$|^GB\d{2}[A-Z]{4}\d{14}$/i;

            if (!field || field.length === 0) return false;

            const results = pattern.test(field);

            return results !== false;
        }

        /**
         * check if IBAN is already in the dropdown #selectStoredIban
         */
        function checkIbanInSelect(iban: string) {
            let hasIban = false;

            let options = form.querySelectorAll('#selectStoredIban > option');
            options = [].slice.call(options);
            options.forEach((el: HTMLElement) => {
                if (iban == el.getAttribute('data-iban')) {
                    hasIban = true;
                }
            });

            return hasIban;
        }

        /**
         * show/hide form and if needed, prefill IBAN and Accountholder
         */
        function updateBankAccount(mode: string) {
            const selected: HTMLSelectElement = form.querySelector('#selectStoredIban');
            const selectedDD = selected && selected.selectedOptions[0].value;
            let iban = '';
            let accountholder = '';

            if (mode === 'load') { // onload
                const storedIban = form.querySelector('.data-iban');
                iban = storedIban && storedIban.innerHTML;
                const storedAccountHolder = form.querySelector('.data-accountholder');
                accountholder = storedAccountHolder && storedAccountHolder.innerHTML;
            } else { // onchange
                const selectedIban = form.querySelector('#selectStoredIban option[selected]');
                iban = selectedIban && selectedIban.getAttribute('data-iban');
                accountholder = selectedIban && selectedIban.getAttribute('data-accountholder');
            }

            if (selectedDD === 'new') {
                form.querySelectorAll('#form-fieldset-bankaccount').forEach((e: HTMLElement) => e.style.display = 'block');
                form.querySelectorAll('#input-field-accountholder, #input-field-iban').forEach((e: HTMLInputElement) => e.value = '');
                form.querySelectorAll('#input-field-accountholder').forEach((e: HTMLInputElement) => e.value = '');
            } else if (selectedDD !== '' && checkIbanInSelect(iban)) {
                const selectedIban: any = form.querySelector('#selectStoredIban option[selected]');
                const newIban = form.querySelectorAll('#form-fieldset-bankaccount .formfield');
                newIban.forEach((e: HTMLDivElement) => e.classList.remove('valid'));
                iban = selectedIban && selectedIban.getAttribute('data-iban');
                accountholder = selectedIban && selectedIban.getAttribute('data-accountholder');

                form.querySelectorAll('#input-field-accountholder').forEach((e: HTMLInputElement) => e.value = accountholder);
                form.querySelectorAll('#input-field-iban').forEach((e: HTMLInputElement) => e.value = iban);

                form.querySelectorAll('#form-fieldset-bankaccount').forEach((e: HTMLElement) => e.style.display = 'none');
            } else if (checkIban(iban)) {
                form.querySelectorAll('#form-fieldset-bankaccount').forEach((e: HTMLElement) => e.style.display = 'block');
                //form.querySelectorAll('#selectStoredIban').forEach((e: HTMLInputElement) => e.value = 'new');
            } else {
                form.querySelectorAll('#form-fieldset-bankaccount').forEach((e: HTMLElement) => e.style.display = 'none');
            }

            if (form.querySelector('#selectStoredIban') === null) {
                form.querySelectorAll('#form-fieldset-bankaccount').forEach((e: HTMLElement) => e.style.display = 'block');
            }
        }

        document.addEventListener('DOMContentLoaded', () => {
            if (form !== null) {
                const selectStoredIban = form.querySelector('#selectStoredIban');
                if (selectStoredIban !== null) {
                    selectStoredIban.addEventListener('change', () => {
                        updateBankAccount('change');
                    });
                }

                updateBankAccount('load');
            }
        });
    }

    handleVoucherCodes() {
        const _this = this;

        function openSummaryVoucher() {
            document.querySelector('.toggle-basket-summary-voucher').classList.add('active');
            (<HTMLElement>document.querySelector('.basket-summary-voucher')).style.maxHeight = (<HTMLElement>document.querySelector('.voucher-content')).offsetHeight + 'px';
        }
        function closeSummaryVoucher() {
            document.querySelector('.toggle-basket-summary-voucher').classList.remove('active');
            (<HTMLElement>document.querySelector('.basket-summary-voucher')).style.maxHeight = '0';
        }

        function deleteCode(code: string) {
            const XHR = new XMLHttpRequest();

            XHR.open( 'DELETE', _this.urlPrefix + '/pricing/cc?code=' + code );
            XHR.setRequestHeader( 'Content-Type', 'application/x-www-form-urlencoded' );
            XHR.onload = function () {
                if (XHR.readyState == 4 && XHR.status == 200) {
                    closeSummaryVoucher();
                    location.reload();
                }
            }
            XHR.send();
        }

        const activeCodes = Array.from(document.querySelectorAll('[data-promocode]'));
        activeCodes.forEach(activeCode => activeCode.addEventListener('click', function() {
            deleteCode(this.getAttribute('data-promocode'));
        }))

        if(document.querySelector('.toggle-basket-summary-voucher')) {
            document.querySelector('.toggle-basket-summary-voucher').addEventListener('click', function (e) {
                if (this.classList.contains('active')) {
                    closeSummaryVoucher();
                } else {
                    openSummaryVoucher();
                }
                e.preventDefault();
            });
        }

        if(document.querySelector('.btn-set-promocode')) {
            document.querySelector('.btn-set-promocode').addEventListener('click', function (e) {
                const inputField: HTMLInputElement = (<HTMLInputElement>document.getElementById('input-field-voucher'));
                const promoCode = inputField.value.trim();

                const XHR = new XMLHttpRequest();

                XHR.open( 'PUT', _this.urlPrefix + '/pricing/cc?code=' + promoCode );
                XHR.setRequestHeader( 'Content-Type', 'application/x-www-form-urlencoded' );
                XHR.setRequestHeader('X-Requested-With', 'XMLHttpRequest')
                XHR.onload = function () {
                    inputField.value = '';
                    const response = XHR.responseText;
                    if(response == 'valid') {
                        closeSummaryVoucher();
                        location.reload();
                    } else {
                        document.getElementById('voucher-invalid-action-content').innerHTML = response;
                        document.getElementById('voucher-invalid-action-box').classList.remove('hidden');
                        (<HTMLElement>document.querySelector('.basket-summary-voucher')).style.maxHeight = (<HTMLElement>document.querySelector('.voucher-content')).offsetHeight + 'px';
                    }
                }
                XHR.send();

                e.preventDefault();
            });
        }
    }

    decodeEntities(str: any) {
        const converted = str.replace(/&#(\d+);/g, function(match: any, dec: any) {
            return String.fromCharCode(dec);
        });

        return converted.replace(/&quot;/g, '"');
    }

    handleAddress() {

        function logError(log: object) {
            async function postData(url: string, data: {}) {
                // Default options are marked with *
                const response = await fetch(url, {
                    method: 'POST', // *GET, POST, PUT, DELETE, etc.
                    mode: 'cors', // no-cors, *cors, same-origin
                    cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
                    credentials: 'same-origin', // include, *same-origin, omit
                    headers: {
                        'Content-Type': 'application/json'
                        // 'Content-Type': 'application/x-www-form-urlencoded',
                    },
                    redirect: 'follow', // manual, *follow, error
                    referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
                    body: JSON.stringify(data) // body data type must match "Content-Type" header
                });
                return response.json(); // parses JSON response into native JavaScript objects
            }

            if(this.failedLogging < 5) {
                postData(this.urlPrefix + '/log/', log)
                  .then(data => {
                      console.log(data); // JSON data parsed by `data.json()` call
                  });
            } else {
            }
        }

        const form = document.querySelector('#form-checkout-address');

        if (form !== null) {
            const activeToggle = form && form.hasAttribute('data-toggleactive');
            let customerProfile = '';

            if (activeToggle) {
                const customerToggleChecked: HTMLInputElement = form.querySelector('[name=customerProfile]:checked');
                customerProfile = customerToggleChecked && customerToggleChecked.value;

                const customerToggle = form.querySelectorAll('[name="customerProfile"]');
                for (var i = 0; i < customerToggle.length; i++) {
                    customerToggle[i].addEventListener('change', (e) => {
                        customerProfile = (<HTMLInputElement>e.target).value;
                        ssiAddressForm.updateForm(customerProfile);
                    });
                }

            } else {
                customerProfile = 'B2B';
            }

            domReady(() => {
                ssiAddressForm.init(form);
                ssiAddressForm.updateForm(customerProfile);
            });

            const loginEnabled: HTMLInputElement = form.querySelector('#input-field-login-enabled');

            if (loginEnabled && loginEnabled.checked) {
                (<HTMLElement>form.querySelector('#login')).style.display = 'block';
            }

            const loginFields: HTMLFieldSetElement = form.querySelector('#login');
            const billingFields: HTMLFieldSetElement = form.querySelector('#billingAddress');
            const deliveryFields: HTMLFieldSetElement = form.querySelector('#deliveryAddress');
            const payerFields: HTMLFieldSetElement = form.querySelector('#payerAddress');

            const checkToggle = form.querySelectorAll('[name="login.enabled"], [name="billingAddress.enabled"], [name="deliveryAddress.enabled"], [name="payerAddress.enabled"]');
            for (let i = 0; i < checkToggle.length; i++) {
                checkToggle[i].addEventListener('change', (e) => {
                    const checkbox: any = e.target;
                    if (checkbox.checked) {
                        if (checkbox.name === 'login.enabled') {
                            loginFields.style.display = 'block';
                        }
                        if (checkbox.name === 'billingAddress.enabled') {
                            billingFields.style.display = 'block';
                        }
                        if (checkbox.name === 'deliveryAddress.enabled') {
                            deliveryFields.style.display = 'block';
                        }
                        if (checkbox.name === 'payerAddress.enabled') {
                            payerFields.style.display = 'block';
                        }
                    } else {
                        if (checkbox.name === 'login.enabled') {
                            loginFields.style.display = 'none';
                        }
                        if (checkbox.name === 'billingAddress.enabled') {
                            billingFields.style.display = 'none';
                        }
                        if (checkbox.name === 'deliveryAddress.enabled') {
                            deliveryFields.style.display = 'none';
                        }
                        if (checkbox.name === 'payerAddress.enabled') {
                            payerFields.style.display = 'none';
                        }
                    }
                });
            }

            const deliverySelect: HTMLSelectElement = form.querySelector('#delivery-address');
            const billingSelect: HTMLSelectElement = form.querySelector('#billing-address');
            const payerSelect: HTMLSelectElement = form.querySelector('#payer-address');

            const deliveryFieldset = form.querySelector('#deliveryAddress-fields');
            const billingFieldset = form.querySelector('#billingAddress-fields');
            const payerFieldset = form.querySelector('#payerAddress-fields');

            let deliveryOptions = form.querySelectorAll('#input-field-delivery-address-dropdown li');
            deliveryOptions = [].slice.call(deliveryOptions);

            deliveryOptions.forEach((element: HTMLElement) => {
                if(element.classList.contains('selected')) {
                    element.parentNode.parentNode.querySelector('.select span').classList.add('selected');
                    element.parentNode.parentNode.querySelector('.select span').innerHTML = element.innerHTML;
                    element.parentNode.parentNode.querySelector('input').setAttribute('value', element.getAttribute('data-value'));
                }

                element.addEventListener('click', () => {
                    const publicId = element.getAttribute('data-public-id');
                    const address = deliveryAddressList[element.getAttribute('data-value')];
                    const name = 'deliveryAddress';

                    helpers.querySetValue(form, "[name='" + name + ".publicId']", publicId);
                    helpers.querySetValue(form, "[name='" + name + ".name']", this.decodeEntities(address.name));
                    helpers.querySetValue(form, "[name='" + name + ".name2']", this.decodeEntities(address.name2));
                    helpers.querySetValue(form, "[name='" + name + ".nameAdditional']", this.decodeEntities(address.nameAdditional));
                    if(address.title == 'f') {
                        (<HTMLInputElement>form.querySelector('#input-field-deliveryAddress-title-female')).checked = true;
                    }
                    else if(address.title == 'm') {
                        (<HTMLInputElement>form.querySelector('#input-field-deliveryAddress-title-male')).checked = true;
                    }
                    else {
                        (<HTMLInputElement>form.querySelector('#input-field-deliveryAddress-title-female')).checked = false;
                        (<HTMLInputElement>form.querySelector('#input-field-deliveryAddress-title-male')).checked = false;
                    }
                    helpers.querySetValue(form, "[name='" + name + ".givenName']", this.decodeEntities(address.givenName));
                    helpers.querySetValue(form, "[name='" + name + ".familyName']", this.decodeEntities(address.familyName));
                    helpers.querySetValue(form, "[name='" + name + ".vatId']", address.vatId);
                    helpers.querySetValue(form, "[name='" + name + ".street']", this.decodeEntities(address.street));
                    helpers.querySetValue(form, "[name='" + name + ".postalCode']", address.postalCode);
                    helpers.querySetValue(form, "[name='" + name + ".city']", this.decodeEntities(address.city));
                    if(document.querySelector('[name="deliveryAddress.phone"]')) {
                        helpers.querySetValue(form, "[name='" + name + ".phone']", this.decodeEntities(address.phone));
                    }
                    if (typeof address.countryCode !== 'undefined' && address.countryCode !== '') {
                        helpers.querySetValue(form, "[name='" + name + ".countryCode']", address.countryCode);
                    }

                    helpers.querySetValue(form, "[name='" + name + ".email']", address.email);

                    deliveryFieldset.querySelectorAll('.input-field-error').forEach((e) => e.remove());
                    deliveryFieldset.querySelectorAll('.msg-error, .msg-success').forEach((e) => e.classList.remove(...['msg-error', 'msg-success']));

                    (<HTMLFieldSetElement>deliveryFieldset).style.display = 'block';
                });
            });

            let billingOptions = form.querySelectorAll('#input-field-billing-address-dropdown li');
            billingOptions = [].slice.call(billingOptions);

            billingOptions.forEach((element: HTMLElement) => {
                if(element.classList.contains('selected')) {
                    element.parentNode.parentNode.querySelector('.select span').classList.add('selected');
                    element.parentNode.parentNode.querySelector('.select span').innerHTML = element.innerHTML;
                    element.parentNode.parentNode.querySelector('input').setAttribute('value', element.getAttribute('data-value'));
                }

                element.addEventListener('click', (e: Event) => {
                    const publicId = element.getAttribute('data-public-id');
                    const address = billingAddressList[element.getAttribute('data-value')];
                    const name = 'billingAddress';

                    // NEED?
                    // if (typeof select !== 'undefined' && select.value !== '') {
                    //     billingSelect.parentElement.style.borderColor = '#d3d3d3';
                    // }

                    helpers.querySetValue(form, "[name='" + name + ".publicId']", publicId);
                    helpers.querySetValue(form, "[name='" + name + ".name']", this.decodeEntities(address.name));
                    helpers.querySetValue(form, "[name='" + name + ".name2']", this.decodeEntities(address.name2));
                    helpers.querySetValue(form, "[name='" + name + ".vatId']", address.vatId);
                    helpers.querySetValue(form, "[name='" + name + ".street']", this.decodeEntities(address.street));
                    helpers.querySetValue(form, "[name='" + name + ".postalCode']", address.postalCode);
                    helpers.querySetValue(form, "[name='" + name + ".city']", this.decodeEntities(address.city));

                    if (typeof address.countryCode !== 'undefined' && address.countryCode !== '') {
                        helpers.querySetValue(form, "[name='" + name + ".countryCode']", address.countryCode);
                    }

                    helpers.querySetValue(form, "[name='" + name + ".email']", address.email);

                    billingFieldset.querySelectorAll('.input-field-error').forEach((e) => e.remove());
                    billingFieldset.querySelectorAll('.msg-error, .msg-success').forEach((e) => e.classList.remove(...['msg-error', 'msg-success']));

                    (<HTMLFieldSetElement>billingFieldset).style.display = 'block';
                });
            });

            let payerOptions = form.querySelectorAll('#input-field-payer-address-dropdown li');
            payerOptions = [].slice.call(payerOptions);

            payerOptions.forEach((element: HTMLElement) => {
                if(element.classList.contains('selected')) {
                    element.parentNode.parentNode.querySelector('.select span').classList.add('selected');
                    element.parentNode.parentNode.querySelector('.select span').innerHTML = element.innerHTML;
                    element.parentNode.parentNode.querySelector('input').setAttribute('value', element.getAttribute('data-value'));
                }

                element.addEventListener('click', (e: Event) => {
                    const publicId = element.getAttribute('data-public-id');
                    const address = payerAddressList[element.getAttribute('data-value')];
                    const name = 'payerAddress';

                    // NEED?
                    // if (typeof select !== 'undefined' && select.value !== '') {
                    //     payerSelect.parentElement.style.borderColor = '#d3d3d3';
                    // }

                    helpers.querySetValue(form, "[name='" + name + ".publicId']", publicId);
                    helpers.querySetValue(form, "[name='" + name + ".name']", this.decodeEntities(address.name));
                    helpers.querySetValue(form, "[name='" + name + ".name2']", this.decodeEntities(address.name2));
                    helpers.querySetValue(form, "[name='" + name + ".vatId']", address.vatId);
                    helpers.querySetValue(form, "[name='" + name + ".street']", this.decodeEntities(address.street));
                    helpers.querySetValue(form, "[name='" + name + ".postalCode']", address.postalCode);
                    helpers.querySetValue(form, "[name='" + name + ".city']", this.decodeEntities(address.city));

                    if (typeof address.countryCode !== 'undefined' && address.countryCode !== '') {
                        helpers.querySetValue(form, "[name='" + name + ".countryCode']", address.countryCode);
                    }

                    helpers.querySetValue(form, "[name='" + name + ".email']", address.email);

                    payerFieldset.querySelectorAll('.input-field-error').forEach((e) => e.remove());
                    payerFieldset.querySelectorAll('.msg-error, .msg-success').forEach((e) => e.classList.remove(...['msg-error', 'msg-success']));

                    (<HTMLFieldSetElement>payerFieldset).style.display = 'block';
                });
            });

            //domReady(() => {
            // NEED?
            // billingSelect !== null && (billingSelect.parentElement.style.borderColor = 'yellow');
            // deliverySelect !== null && (deliverySelect.parentElement.style.borderColor = 'blue');
            // payerSelect !== null && (payerSelect.parentElement.style.borderColor = 'green');
            //});

            domReady(() => {
                const addressIdent = document.querySelector('#address-detection');
                const hasDeliveryId = addressIdent.hasAttribute('data-delivery');
                const hasBillingId = addressIdent.hasAttribute('data-billing');
                const hasPayerId = addressIdent.hasAttribute('data-payer');

                if (hasDeliveryId) {
                    (<HTMLDivElement>deliveryFieldset).style.display = 'block';
                }
                if (hasBillingId) {
                    (<HTMLDivElement>billingFieldset).style.display = 'block';
                }
                if (hasPayerId) {
                    (<HTMLDivElement>payerFieldset).style.display = 'block';
                }

                let countryCodes = form.querySelectorAll('#dropdown-input-field-mainAddress-countryCode li');
                countryCodes = [].slice.call(countryCodes);

                countryCodes.forEach((element: HTMLElement) => {
                    element.addEventListener('click', () => {
                        const mainCountry = helpers.querySelectValue(form, 'input[name="mainAddress.countryCode"]');
                        if (deliveryCountryCodes.indexOf(mainCountry) === -1) {
                            (<HTMLDivElement>form.querySelector('#message-different-country')).style.display = 'block';
                            var log = {
                                type: 'INFO',
                                message: 'message-different-country - ' + mainCountry,
                                source: 'registration_form.ftl',
                                line: '0',
                                col: '0',
                                stack: '',
                                logLevel: 'vertical',
                                vertical: 'user',
                                clientLocale: '-',
                                tenant: '-',
                            };

                            logError(log);
                        } else {
                            (<HTMLDivElement>form.querySelector('#message-different-country')).style.display = 'none';
                        }
                    });
                });
            });

            const industryField: HTMLDivElement = form.querySelector('#dropdown-input-field-industryName');
            const industryInput: HTMLInputElement = form.querySelector('#input-field-industryName-search');

            industryField && industryField.addEventListener('click', () => {
                industryInput.value = '';
            });
        }

    }

    handleTechReturns() {
        domReady(() => {
            if(document.querySelector('[id^="input-field-techReturn-"]')) {
                const inputs = [].slice.call(document.querySelectorAll('[id^="input-field-techReturn-"]'));
                inputs.forEach((input:HTMLInputElement) => {
                    input.addEventListener('change', function() {
                        const cartItemId = this.dataset.cartitemid;
                        let data;

                        if (this.checked) {
                            data = 'techReturnWanted=true';
                        } else {
                            data = 'techReturnWanted=false';
                        }

                        const XHR = new XMLHttpRequest()
                        XHR.open('POST', '/order/cart/item/' + cartItemId + '/tech-return-wanted')
                        XHR.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded')
                        XHR.setRequestHeader('X-Requested-With', 'XMLHttpRequest')
                        XHR.send(data);
                    })
                })
            }
        });
    }

    private async handleWishlistItems() {
        const identitySub = document.querySelector('[data-identity-sub]')?.getAttribute('data-identity-sub');
        const articleIdElements = document.querySelectorAll('[data-order-cart-article-id]');
        const articleIds = Array.from(articleIdElements).map((element) => element.getAttribute('data-order-cart-article-id'));

        if (!identitySub) return console.warn("No identity found for user.");

        try {
            const wishlistResponse = await fetch('/user/wishlists?identitySub=' + identitySub);
            if (!wishlistResponse.ok) new Error(`Could not update wishlist icons in cart: ${wishlistResponse.status}`);

            const wishlistItems: Array<string> = await wishlistResponse.json();

            const results = wishlistItems.filter(item => articleIds.includes(item));
            results.forEach(articleId => {
                const articleElement: HTMLDivElement = document.querySelector(`[data-order-cart-article-id="${articleId}"]`);
                if (!articleElement) return console.warn('Article not found');

                const articleIsNotOnWishlistElement: HTMLSpanElement = articleElement.querySelector('[data-article-not-on-wishlist]');
                const articleIsOnWishlistElement: HTMLSpanElement = articleElement.querySelector('[data-article-on-wishlist]');

                // continue loop if elements not found (like not available items in cart)
                if (!articleIsNotOnWishlistElement || !articleIsOnWishlistElement) return;

                this.showArticleIsOnWishlist(
                  articleIsNotOnWishlistElement,
                  articleIsOnWishlistElement,
                );
                this.handleRemoveArticleFromWishlistClick(
                  articleElement,
                  articleIsNotOnWishlistElement,
                  articleIsOnWishlistElement,
                  articleId
                );
            })
        } catch (error) {
            console.error(error);
        }
    }

    private handleEvents() {
        // Reload cart if an item is added to wishlist
        document.addEventListener('ssi-wishlist-item-added', () => window.location.reload());
    }

    // HELPER FUNCTIONS

    private showArticleIsOnWishlist(
      articleIsNotOnWishlistElement: HTMLSpanElement,
      articleIsOnWishlistElement: HTMLSpanElement,
    ) {
        articleIsNotOnWishlistElement.classList.add('hidden');
        articleIsOnWishlistElement.classList.remove('hidden');
    }

    private hideArticleIsOnWishlist(
      articleIsNotOnWishlistElement: HTMLSpanElement,
      articleIsOnWishlistElement: HTMLSpanElement,
    ) {
        articleIsNotOnWishlistElement.classList.remove('hidden');
        articleIsOnWishlistElement.classList.add('hidden');
    }

    private handleRemoveArticleFromWishlistClick(
      articleElement: HTMLDivElement,
      articleIsNotOnWishlistElement: HTMLSpanElement,
      articleIsOnWishlistElement: HTMLSpanElement,
      articleId: string
    ) {
        if (!articleElement || !articleIsNotOnWishlistElement || !articleIsOnWishlistElement)
            return console.error('Could not delete article from wishlist because of missing elements');
        if (!articleId) return console.error('Could not delete article from wishlist because of missing articleId');

        const productId = articleElement.getAttribute('data-order-item-id');
        if (!productId) return console.error('Could not delete article from wishlist because of missing productId');

        const headers = new Headers();
        headers.set('Content-Type', 'application/x-www-form-urlencoded');

        articleIsOnWishlistElement.addEventListener('click', async () => {
            try {
                const response = await fetch('/user/my-shop/wishlist/delete-item', {
                    method: 'POST',
                    headers,
                    body: JSON.stringify({ articleId, productId }),
                });
                if (!response.ok) throw new Error(`Could not delete wishlist item: ${response.status}`);

                this.hideArticleIsOnWishlist(articleIsNotOnWishlistElement, articleIsOnWishlistElement);
            } catch (error) {
                console.error(error);
            }
        })
    }

    private isAnyVoucherCodeAvailable(cartSummaryModel: CartSummaryModel, cartItemPrices: Array<CartItemPrice>) {
        return cartSummaryModel?.appliedDiscounts?.length > 0 ||
          cartSummaryModel?.missedAppliedActions?.length > 0 ||
          cartItemPrices.some(item => item.appliedDiscounts?.length > 0);
    }

    init() {
        this.getFtlData();
        this.paymentMethods();
        this.handleVoucherCodes();
        this.handleAddress();
        this.handleTechReturns();
        this.handleWishlistItems();
        this.handleEvents();
    }

}
